var ImageZoom, Product,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  slice = [].slice,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

window.BlogView = (function(superClass) {
  extend(BlogView, superClass);

  function BlogView() {
    return BlogView.__super__.constructor.apply(this, arguments);
  }

  BlogView.prototype.initialize = function() {
    this.sectionBinding();
    return this.render();
  };

  BlogView.prototype.render = function() {
    this.grid = this.$("[data-blog]");
    if (this.grid.length) {
      return this.initializeMasonryGrid();
    }
  };

  BlogView.prototype.sectionBinding = function() {
    this.$el.on('shopify:section:load', (function(_this) {
      return function() {
        _this.delegateEvents();
        return _this.render();
      };
    })(this));
    return this.$el.on('shopify:section:unload', (function(_this) {
      return function() {
        return _this.undelegateEvents();
      };
    })(this));
  };

  BlogView.prototype.initializeMasonryGrid = function() {
    this.grid.masonry({
      itemSelector: "[data-article-item]",
      columnWidth: ".article-grid-sizer",
      gutter: ".article-gutter-sizer",
      percentPosition: true
    });
    return this.grid.imagesLoaded().progress((function(_this) {
      return function(instance, image) {
        return _this.grid.data('masonry').layout();
      };
    })(this));
  };

  return BlogView;

})(Backbone.View);

window.ProductListView = (function(superClass) {
  extend(ProductListView, superClass);

  function ProductListView() {
    return ProductListView.__super__.constructor.apply(this, arguments);
  }

  ProductListView.prototype.events = {
    "preload-images": "preloadImages"
  };

  ProductListView.prototype.initialize = function() {
    return this.preloadImages();
  };

  ProductListView.prototype.preloadImages = function(e, imageWrap) {
    var j, len, ref, results;
    ref = this.$(".product-item-image");
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      imageWrap = ref[j];
      results.push(this.showImage(imageWrap));
    }
    return results;
  };

  ProductListView.prototype.showImage = function(imageWrap) {
    var image;
    imageWrap = $(imageWrap);
    image = imageWrap.find("img");
    return imageWrap.imagesLoaded((function(_this) {
      return function() {
        if (image.height() < 100) {
          return imageWrap.find(".product-details-overlay").addClass("landscape");
        }
      };
    })(this));
  };

  return ProductListView;

})(Backbone.View);

window.CollectionView = (function(superClass) {
  extend(CollectionView, superClass);

  function CollectionView() {
    return CollectionView.__super__.constructor.apply(this, arguments);
  }

  CollectionView.prototype.events = {
    "click .click-to-load-button": "loadNewProducts",
    "change .collection-sort-filter select": "updateSortFilter",
    "change .collection-tag-filter select": "updateTagFilter"
  };

  CollectionView.prototype.initialize = function() {
    this.productListView = null;
    this.$productList = null;
    this.setQueryParams();
    this.sectionBinding();
    return this.render();
  };

  CollectionView.prototype.render = function() {
    this.productListView = new ProductListView({
      el: this.$(".collection-content")
    });
    this.$productList = this.$(".product-list");
    if (this.$('.collection-tag-filter').length) {
      new SelectView({
        el: this.$('.collection-tag-filter select')
      });
    }
    if (this.$('.collection-sort-filter').length) {
      new SelectView({
        el: this.$('.collection-sort-filter select')
      });
    }
    if (this.$("#content").hasClass("has-pagination") && (this.$("#content").hasClass("click-to-load") || this.$("#content").hasClass("infinite-scroll"))) {
      return this.initializeInfiniteScroll();
    }
  };

  CollectionView.prototype.remove = function() {
    return this.$productList.infinitescroll('destroy');
  };

  CollectionView.prototype.sectionBinding = function() {
    this.$el.on('shopify:section:load', (function(_this) {
      return function() {
        _this.delegateEvents();
        return _this.render();
      };
    })(this));
    return this.$el.on('shopify:section:unload', (function(_this) {
      return function() {
        _this.remove();
        _this.$productList = null;
        _this.productListView.remove();
        return _this.undelegateEvents();
      };
    })(this));
  };

  CollectionView.prototype.initializeInfiniteScroll = function() {
    var behavior;
    this.clickToLoad = this.$(".click-to-load-button");
    this.section = JSON.parse($('[data-section-json]', this.$el).text());
    this.paginateMethod = this.section.products_pagination_method;
    this.currentProductsCount = this.$(".product-item").length;
    if (this.paginateMethod === "click-to-load") {
      behavior = "twitter";
    } else {
      behavior = "";
    }
    return this.$productList.infinitescroll({
      behavior: behavior,
      navSelector: "#pagination",
      nextSelector: "#pag-next a",
      itemSelector: ".product-item",
      loading: {
        finishedMsg: "",
        img: "",
        msg: null,
        msgText: "",
        selector: null,
        speed: "fast",
        start: void 0,
        bufferPx: 200
      }
    }, (function(_this) {
      return function(newProducts) {
        return _this.onProductsLoad(newProducts);
      };
    })(this));
  };

  CollectionView.prototype.onProductsLoad = function(newProducts) {
    var ref;
    this.$productList.trigger("preload-images", [newProducts]);
    if (Theme.currencySwitcher) {
      $(".currency-switcher select").trigger("reset-currency");
    }
    this.currentProductsCount = this.currentProductsCount + $(newProducts).length;
    if (this.currentProductsCount === parseInt(this.$productList.data("product-count"))) {
      this.clickToLoad.hide();
      this.$(".collection-content").addClass("no-pagination");
    }
    if ((ref = Shopify.PaymentButton) != null) {
      ref.init();
    }
    return $(".product-item", this.$productList).each(function() {
      return rimg["shopify"].watch(this);
    });
  };

  CollectionView.prototype.loadNewProducts = function(e) {
    return this.$productList.infinitescroll("retrieve");
  };

  CollectionView.prototype.setQueryParams = function() {
    var aCouples, aKeyValue, i, j, ref, results;
    Shopify.queryParams = {};
    if (location.search.length) {
      aKeyValue = void 0;
      aCouples = location.search.substr(1).split('&');
      results = [];
      for (i = j = 0, ref = aCouples.length - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
          results.push(Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]));
        } else {
          results.push(void 0);
        }
      }
      return results;
    }
  };

  CollectionView.prototype.updateSortFilter = function(e) {
    var Sorting, currentSearch, index, j, len, part, search, searchParts;
    Sorting = {};
    Sorting.sort_by = this.$(".collection-sort-filter select").val();
    if ($(e.target).closest(".collection-sorting").hasClass("vendor-collection")) {
      currentSearch = location.search;
      searchParts = currentSearch.split("&");
      for (index = j = 0, len = searchParts.length; j < len; index = ++j) {
        part = searchParts[index];
        if (part.indexOf("sort_by") !== -1) {
          searchParts.splice(index, 1);
        }
      }
      search = searchParts.join("&");
      return location.search = search + "&" + (jQuery.param(Sorting));
    } else {
      return location.search = jQuery.param(Sorting);
    }
  };

  CollectionView.prototype.updateTagFilter = function(e) {
    var collection, tag;
    collection = $(e.target).data("collection");
    tag = $(e.target).val();
    if (tag === "all") {
      return window.location.href = "/collections/" + collection + "?" + ($.param(Shopify.queryParams));
    } else {
      return window.location.href = "/collections/" + collection + "/" + tag + "?" + ($.param(Shopify.queryParams));
    }
  };

  return CollectionView;

})(Backbone.View);

window.CurrencyView = (function(superClass) {
  extend(CurrencyView, superClass);

  function CurrencyView() {
    return CurrencyView.__super__.constructor.apply(this, arguments);
  }

  CurrencyView.prototype.events = {
    "change [name=currencies]": "switchCurrency",
    "switch-currency": "switchCurrency",
    "reset-currency": "switchCurrency"
  };

  CurrencyView.prototype.initialize = function() {
    this.sectionBinding();
    return this.render();
  };

  CurrencyView.prototype.sectionBinding = function() {
    this.$el.on('shopify:section:load', (function(_this) {
      return function() {
        _this.delegateEvents();
        return _this.render();
      };
    })(this));
    return this.$el.on('shopify:section:unload', (function(_this) {
      return function() {
        return _this.undelegateEvents();
      };
    })(this));
  };

  CurrencyView.prototype.render = function() {
    var doubleMoney, j, l, len, len1, money, newCurrency, ref, ref1;
    this.$currencySwitcher = this.$("[name=currencies]");
    Currency.format = Theme.currencySwitcherFormat;
    Currency.money_with_currency_format = {};
    Currency.money_with_currency_format[Theme.currency] = Theme.moneyFormatCurrency;
    Currency.money_format = {};
    Currency.money_format[Theme.currency] = Theme.moneyFormat;
    newCurrency = Currency.cookie.read();
    if (newCurrency && this.$currencySwitcher.find("option[value=" + newCurrency + "]")) {
      Currency.currentCurrency = newCurrency;
    } else if (Theme.defaultCurrency) {
      Currency.currentCurrency = Theme.defaultCurrency;
      Currency.cookie.write(Theme.defaultCurrency);
    } else {
      Currency.currentCurrency = Theme.currency;
      Currency.cookie.write(Theme.currency);
    }
    this.$currencySwitcher.val(Currency.currentCurrency);
    ref = this.$("span.money span.money");
    for (j = 0, len = ref.length; j < len; j++) {
      doubleMoney = ref[j];
      $(doubleMoney).parents("span.money").removeClass("money");
    }
    ref1 = this.$("span.money");
    for (l = 0, len1 = ref1.length; l < len1; l++) {
      money = ref1[l];
      $(money).attr("data-currency-" + Theme.currency, $(money).html());
    }
    return this.switchCurrency();
  };

  CurrencyView.prototype.switchCurrency = function(e) {
    var $money, $switcher, j, len, money, newCurrency, ref;
    $switcher = this.$currencySwitcher;
    newCurrency = $switcher.val();
    if (e !== void 0) {
      $switcher = $(e.currentTarget);
      if ($switcher !== void 0 && ($switcher != null ? $switcher.attr('name') : void 0) === 'currencies') {
        this.$currencySwitcher.val($switcher.val());
        newCurrency = $switcher.val();
      }
    }
    if (newCurrency === null || newCurrency === '') {
      newCurrency = Theme.currency;
    }
    ref = $("span.money");
    for (j = 0, len = ref.length; j < len; j++) {
      money = ref[j];
      $money = $(money);
      if (!$(money).attr('data-currency-' + Theme.currency)) {
        $(money).attr('data-currency-' + Theme.currency, $(money).html());
      }
      $money.html($money.attr("data-currency-" + Theme.currency));
      $money.attr("data-currency", Theme.currency);
    }
    Currency.convertAll(Theme.currency, newCurrency);
    Currency.currentCurrency = newCurrency;
    Currency.cookie.write(newCurrency);
    return this.$(".selected-currency").text(Currency.currentCurrency);
  };

  return CurrencyView;

})(Backbone.View);

window.GiftCardView = (function(superClass) {
  extend(GiftCardView, superClass);

  function GiftCardView() {
    return GiftCardView.__super__.constructor.apply(this, arguments);
  }

  GiftCardView.prototype.initialize = function() {
    return this.addQrCode();
  };

  GiftCardView.prototype.addQrCode = function() {
    var qrWrapper;
    qrWrapper = $('[data-qr-code]');
    return new QRCode(qrWrapper[0], {
      text: qrWrapper.data('qr-code'),
      width: 120,
      height: 120
    });
  };

  return GiftCardView;

})(Backbone.View);

window.NavigationView = (function(superClass) {
  extend(NavigationView, superClass);

  function NavigationView() {
    return NavigationView.__super__.constructor.apply(this, arguments);
  }

  NavigationView.prototype.events = {
    "click .navigation-desktop .dropdown > a": "toggleMenu",
    "click .navigation-mobile .dropdown > a": "toggleMenu",
    "click .mobile-nav-item.navigate > a": "toggleMobileNav",
    "click .mobile-nav-item.browse > a": "toggleMobileSearch",
    "click .mobile-nav-item > a": "toggleMobileNavItemsFadeStatus"
  };

  NavigationView.prototype.initialize = function() {
    this.body = $(document.body);
    return this.desktopNav = this.$("[data-desktop-nav]");
  };

  NavigationView.prototype.toggleMenu = function(e) {
    var a, dropdown, handle, megaDropdown, megaMenuHeight;
    a = this.$(e.currentTarget);
    dropdown = a.parent(".dropdown");
    handle = dropdown.data('handle');
    megaDropdown = a.parent(".nav-item-meganav");
    this.$megaMenus = this.$(".navigation-desktop-mega");
    this.$megaMenu = this.$(".navigation-desktop-mega[data-parent=\"" + handle + "\"]");
    megaMenuHeight = this.$megaMenu.outerHeight();
    if (dropdown.hasClass("active") || megaDropdown.hasClass("active")) {
      return;
    }
    e.preventDefault();
    dropdown.toggleClass("active");
    dropdown.siblings(".dropdown").removeClass("active");
    dropdown.find(".dropdown-nav .dropdown").removeClass("active");
    this.$megaMenus.removeClass("active").css("height", "");
    if (megaDropdown.hasClass("active")) {
      this.$megaMenu.toggleClass("active").css("height", megaMenuHeight);
    } else {
      this.$megaMenu.removeClass("active").css("height", "");
    }
    $(window).resize((function(_this) {
      return function() {
        if (document.documentElement.offsetWidth < 768 && megaDropdown.hasClass("active")) {
          _this.$megaMenus.removeClass("active");
          return dropdown.toggleClass("active");
        }
      };
    })(this)).trigger("resize");
    return this.adjustSimpleNavPosition();
  };

  NavigationView.prototype.adjustSimpleNavPosition = function() {
    var item, itemOffset, j, len, navWidth, ref, results;
    navWidth = this.desktopNav.width();
    ref = this.$(".navigation-desktop > .dropdown");
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      item = ref[j];
      this.$item = $(item);
      if (!this.$item.hasClass("nav-item-meganav")) {
        itemOffset = this.$item.offset();
        if (this.$item.find(".second-tier").length && itemOffset.left + 218 > navWidth && $(window).width() < navWidth + 436) {
          this.$item.find(".second-tier").addClass("adjust-right");
        } else if (this.$item.find(".second-tier").length) {
          this.$item.find(".second-tier").removeClass("adjust-right");
        }
        if (this.$item.find(".third-tier").length && itemOffset.left + 436 > navWidth && $(window).width() < navWidth + 872) {
          results.push(this.$item.find(".third-tier").addClass("adjust-right"));
        } else if (this.$item.find(".third-tier").length) {
          results.push(this.$item.find(".third-tier").removeClass("adjust-right"));
        } else {
          results.push(void 0);
        }
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  NavigationView.prototype.toggleMobileNav = function(e) {
    this.$(".navigation-mobile-list").toggleClass("active");
    return this.$(".mobile-browse-container").removeClass("active");
  };

  NavigationView.prototype.toggleMobileSearch = function(e) {
    this.$(".mobile-browse-container").toggleClass("active");
    return this.$(".navigation-mobile-list").removeClass("active");
  };

  NavigationView.prototype.toggleMobileNavItemsFadeStatus = function(e) {
    var navItems, target;
    navItems = this.$(".mobile-nav-item");
    target = $(e.target).closest(navItems);
    if (target.hasClass("active")) {
      navItems.removeClass("fade");
      return target.removeClass("active");
    } else {
      navItems.not(target).addClass("fade");
      return target.addClass("active").removeClass("fade");
    }
  };

  return NavigationView;

})(Backbone.View);

window.HeaderView = (function(superClass) {
  extend(HeaderView, superClass);

  function HeaderView() {
    return HeaderView.__super__.constructor.apply(this, arguments);
  }

  HeaderView.prototype.events = {
    "click .search-toggle-button": "toggleSearch",
    "change .shop-by-category, .shop-by-vendor": "fireSearchSelect"
  };

  HeaderView.prototype.initialize = function() {
    this.navigation = new NavigationView({
      el: this.$el
    });
    return $(document.body).on("click", (function(_this) {
      return function(e) {
        if (!_this.$(e.target).closest(".search-toggle-button").length) {
          return _this.$(".search-toggle-button").removeClass("open");
        }
      };
    })(this));
  };

  HeaderView.prototype.toggleSearch = function(e) {
    if (this.$(".search-toggle-button").hasClass("open") && this.$(e.target).hasClass("search-browse-parent-outline")) {
      return this.$(".search-toggle-button").removeClass("open");
    } else {
      this.$(".search-browse-container").css({
        top: $(".search-browse-parent-outline").height()
      });
      return this.$(".search-toggle-button").addClass("open");
    }
  };

  HeaderView.prototype.fireSearchSelect = function(e) {
    var target;
    target = this.$(e.target);
    if (target.val().length) {
      return window.location = target.val();
    }
  };

  HeaderView.prototype.prepareRemove = function() {
    return this.navigation.remove();
  };

  return HeaderView;

})(Backbone.View);

window.SlideshowView = (function(superClass) {
  extend(SlideshowView, superClass);

  function SlideshowView() {
    return SlideshowView.__super__.constructor.apply(this, arguments);
  }

  SlideshowView.prototype.initialize = function() {
    this.flickity = null;
    return this._validate();
  };

  SlideshowView.prototype.update = function($el) {
    this.$el = $el;
    if (this.flickity == null) {
      return this._validate();
    }
  };

  SlideshowView.prototype.remove = function() {
    this.$slideshow.flickity('destroy');
  };

  SlideshowView.prototype.onBlockSelect = function(event) {
    var $slideIndex, $slides;
    $slides = $("[data-slideshow-slide]", this.$el);
    $slideIndex = $slides.index(event.target);
    if (this.$slideshow) {
      this.$slideshow.flickity('select', $slideIndex, false, false);
      return this.$slideshow.flickity('pausePlayer');
    }
  };

  SlideshowView.prototype.onBlockDeselect = function(event) {
    return this.$slideshow.flickity('unpausePlayer');
  };

  SlideshowView.prototype._validate = function() {
    var autoplay, slideCount;
    this.$slideshow = $('[data-slideshow]', this.$el);
    this.$slideshowContents = $('[data-slide-contents]', this.$el);
    slideCount = this.$slideshow.data('slideshow-slides');
    autoplay = this.$slideshow.data('autoplay');
    return this._setupSlideshow(slideCount, autoplay);
  };

  SlideshowView.prototype._setupSlideshow = function(slideCount, autoplay) {
    var originalSelect, slideshowNavigation;
    slideshowNavigation = true;
    if (slideCount === 1) {
      slideshowNavigation = false;
    }
    Flickity.prototype.setGallerySize = function() {
      var height;
      if (this.options.setGallerySize) {
        height = this.maxCellHeight;
        if (this.options.adaptiveHeight && this.selectedCell) {
          height = this.selectedCell.size.outerHeight;
        }
        return this.viewport.style.height = height + "px";
      }
    };
    originalSelect = Flickity.prototype.select;
    Flickity.prototype.select = function() {
      originalSelect.apply(this, arguments);
      if (this.options.adaptiveHeight) {
        return this.setGallerySize();
      }
    };
    this.$slideshow.flickity({
      imagesLoaded: true,
      autoPlay: autoplay,
      pageDots: false,
      prevNextButtons: slideshowNavigation,
      contain: true,
      cellSelector: ".slide",
      wrapAround: true,
      resize: true,
      adaptiveHeight: true
    });
    this.flickity = this.$slideshow.data('flickity');
    this.$viewPort = this.$slideshow.find('.flickity-viewport');
    this.$slide = this.$slideshow.find('.slide');
    return this.$slideshow.on("cellSelect", (function(_this) {
      return function() {
        var index;
        index = _this.flickity.selectedIndex;
        _this.$slideshowContents.removeClass('slide-contents-visible');
        _this.$slideshowContents.filter("[data-slide-index=\"" + index + "\"]").addClass("slide-contents-visible");
        return $(_this.flickity.selectedElement).trigger("theme:rimg:watch");
      };
    })(this));
  };

  return SlideshowView;

})(Backbone.View);


/*********************************************************************
*  #### Twitter Post Fetcher v17.0.3 ####
*  Coded by Jason Mayes 2015. A present to all the developers out there.
*  www.jasonmayes.com
*  Please keep this disclaimer with my code if you use it. Thanks. :-)
*  Got feedback or questions, ask here:
*  http://www.jasonmayes.com/projects/twitterApi/
*  Github: https://github.com/jasonmayes/Twitter-Post-Fetcher
*  Updates will be posted to this site.
*********************************************************************/
(function(root,factory){if(typeof define==='function'&&define.amd){define([],factory);}else if(typeof exports==='object'){module.exports=factory();}else{factory();}}(this,function(){var domNode='';var maxTweets=20;var parseLinks=true;var queue=[];var inProgress=false;var printTime=true;var printUser=true;var formatterFunction=null;var supportsClassName=true;var showRts=true;var customCallbackFunction=null;var showInteractionLinks=true;var showImages=false;var useEmoji=false;var targetBlank=true;var lang='en';var permalinks=true;var dataOnly=false;var script=null;var scriptAdded=false;function handleTweets(tweets){if(customCallbackFunction===null){var x=tweets.length;var n=0;var element=document.getElementById(domNode);var html='<ul>';while(n<x){html+='<li>'+tweets[n]+'</li>';n++;}
html+='</ul>';element.innerHTML=html;}else{customCallbackFunction(tweets);}}
function strip(data){return data.replace(/<b[^>]*>(.*?)<\/b>/gi,function(a,s){return s;}).replace(/class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi,'');}
function targetLinksToNewWindow(el){var links=el.getElementsByTagName('a');for(var i=links.length-1;i>=0;i--){links[i].setAttribute('target','_blank');}}
function getElementsByClassName(node,classname){var a=[];var regex=new RegExp('(^| )'+classname+'( |$)');var elems=node.getElementsByTagName('*');for(var i=0,j=elems.length;i<j;i++){if(regex.test(elems[i].className)){a.push(elems[i]);}}
return a;}
function extractImageUrl(image_data){if(image_data!==undefined&&image_data.innerHTML.indexOf('data-image')>=0){var data_src=image_data.innerHTML.match(/data-image=\"([A-z0-9]+:\/\/[A-z0-9]+\.[A-z0-9]+\.[A-z0-9]+\/[A-z0-9]+\/[A-z0-9\-]+)/i)[1];return decodeURIComponent(data_src)+'.jpg';}}
var twitterFetcher={fetch:function(config){if(config.maxTweets===undefined){config.maxTweets=20;}
if(config.enableLinks===undefined){config.enableLinks=true;}
if(config.showUser===undefined){config.showUser=true;}
if(config.showTime===undefined){config.showTime=true;}
if(config.dateFunction===undefined){config.dateFunction='default';}
if(config.showRetweet===undefined){config.showRetweet=true;}
if(config.customCallback===undefined){config.customCallback=null;}
if(config.showInteraction===undefined){config.showInteraction=true;}
if(config.showImages===undefined){config.showImages=false;}
if(config.useEmoji===undefined){config.useEmoji=false;}
if(config.linksInNewWindow===undefined){config.linksInNewWindow=true;}
if(config.showPermalinks===undefined){config.showPermalinks=true;}
if(config.dataOnly===undefined){config.dataOnly=false;}
if(inProgress){queue.push(config);}else{inProgress=true;domNode=config.domId;maxTweets=config.maxTweets;parseLinks=config.enableLinks;printUser=config.showUser;printTime=config.showTime;showRts=config.showRetweet;formatterFunction=config.dateFunction;customCallbackFunction=config.customCallback;showInteractionLinks=config.showInteraction;showImages=config.showImages;useEmoji=config.useEmoji;targetBlank=config.linksInNewWindow;permalinks=config.showPermalinks;dataOnly=config.dataOnly;var head=document.getElementsByTagName('head')[0];if(script!==null){head.removeChild(script);}
script=document.createElement('script');script.type='text/javascript';if(config.list!==undefined){script.src='https://syndication.twitter.com/timeline/list?'+'callback=__twttrf.callback&dnt=false&list_slug='+
config.list.listSlug+'&screen_name='+config.list.screenName+'&suppress_response_codes=true&lang='+(config.lang||lang)+'&rnd='+Math.random();}else if(config.profile!==undefined){script.src='https://syndication.twitter.com/timeline/profile?'+'callback=__twttrf.callback&dnt=false'+'&screen_name='+config.profile.screenName+'&suppress_response_codes=true&lang='+(config.lang||lang)+'&rnd='+Math.random();}else if(config.likes!==undefined){script.src='https://syndication.twitter.com/timeline/likes?'+'callback=__twttrf.callback&dnt=false'+'&screen_name='+config.likes.screenName+'&suppress_response_codes=true&lang='+(config.lang||lang)+'&rnd='+Math.random();}else{script.src='https://cdn.syndication.twimg.com/widgets/timelines/'+
config.id+'?&lang='+(config.lang||lang)+'&callback=__twttrf.callback&'+'suppress_response_codes=true&rnd='+Math.random();}
head.appendChild(script);}},callback:function(data){if(data===undefined||data.body===undefined){inProgress=false;if(queue.length>0){twitterFetcher.fetch(queue[0]);queue.splice(0,1);}
return;}
if(!useEmoji){data.body=data.body.replace(/(<img[^c]*class="Emoji[^>]*>)|(<img[^c]*class="u-block[^>]*>)/g,'');}
if(!showImages){data.body=data.body.replace(/(<img[^c]*class="NaturalImage-image[^>]*>|(<img[^c]*class="CroppedImage-image[^>]*>))/g,'');}
if(!printUser){data.body=data.body.replace(/(<img[^c]*class="Avatar"[^>]*>)/g,'');}
var div=document.createElement('div');div.innerHTML=data.body;if(typeof(div.getElementsByClassName)==='undefined'){supportsClassName=false;}
function swapDataSrc(element){var avatarImg=element.getElementsByTagName('img')[0];if(avatarImg && avatarImg.length){avatarImg.src=avatarImg.getAttribute('data-src-2x');}return element;}
var tweets=[];var authors=[];var times=[];var images=[];var rts=[];var tids=[];var permalinksURL=[];var x=0;if(supportsClassName){var tmp=div.getElementsByClassName('timeline-Tweet');while(x<tmp.length){if(tmp[x].getElementsByClassName('timeline-Tweet-retweetCredit').length>0){rts.push(true);}else{rts.push(false);}
if(!rts[x]||rts[x]&&showRts){tweets.push(tmp[x].getElementsByClassName('timeline-Tweet-text')[0]);tids.push(tmp[x].getAttribute('data-tweet-id'));if(printUser){authors.push(swapDataSrc(tmp[x].getElementsByClassName('timeline-Tweet-author')[0]));}
times.push(tmp[x].getElementsByClassName('dt-updated')[0]);permalinksURL.push(tmp[x].getElementsByClassName('timeline-Tweet-timestamp')[0]);if(tmp[x].getElementsByClassName('timeline-Tweet-media')[0]!==undefined){images.push(tmp[x].getElementsByClassName('timeline-Tweet-media')[0]);}else{images.push(undefined);}}
x++;}}else{var tmp=getElementsByClassName(div,'timeline-Tweet');while(x<tmp.length){if(getElementsByClassName(tmp[x],'timeline-Tweet-retweetCredit').length>0){rts.push(true);}else{rts.push(false);}
if(!rts[x]||rts[x]&&showRts){tweets.push(getElementsByClassName(tmp[x],'timeline-Tweet-text')[0]);tids.push(tmp[x].getAttribute('data-tweet-id'));if(printUser){authors.push(swapDataSrc(getElementsByClassName(tmp[x],'timeline-Tweet-author')[0]));}
times.push(getElementsByClassName(tmp[x],'dt-updated')[0]);permalinksURL.push(getElementsByClassName(tmp[x],'timeline-Tweet-timestamp')[0]);if(getElementsByClassName(tmp[x],'timeline-Tweet-media')[0]!==undefined){images.push(getElementsByClassName(tmp[x],'timeline-Tweet-media')[0]);}else{images.push(undefined);}}
x++;}}
if(tweets.length>maxTweets){tweets.splice(maxTweets,(tweets.length-maxTweets));authors.splice(maxTweets,(authors.length-maxTweets));times.splice(maxTweets,(times.length-maxTweets));rts.splice(maxTweets,(rts.length-maxTweets));images.splice(maxTweets,(images.length-maxTweets));permalinksURL.splice(maxTweets,(permalinksURL.length-maxTweets));}
var arrayTweets=[];var x=tweets.length;var n=0;if(dataOnly){while(n<x){arrayTweets.push({tweet:tweets[n].innerHTML,author:authors[n]?authors[n].innerHTML:'Unknown Author',author_data:{profile_url:authors[n]?authors[n].querySelector('[data-scribe="element:user_link"]').href:null,profile_image:authors[n]?authors[n].querySelector('[data-scribe="element:avatar"]').getAttribute('data-src-1x'):null,profile_image_2x:authors[n]?authors[n].querySelector('[data-scribe="element:avatar"]').getAttribute('data-src-2x'):null,screen_name:authors[n]?authors[n].querySelector('[data-scribe="element:screen_name"]').title:null,name:authors[n]?authors[n].querySelector('[data-scribe="element:name"]').title:null},time:times[n].textContent,timestamp:times[n].getAttribute('datetime').replace('+0000','Z').replace(/([\+\-])(\d\d)(\d\d)/,'$1$2:$3'),image:extractImageUrl(images[n]),rt:rts[n],tid:tids[n],permalinkURL:(permalinksURL[n]===undefined)?'':permalinksURL[n].href});n++;}}else{while(n<x){if(typeof(formatterFunction)!=='string'){var datetimeText=times[n].getAttribute('datetime');var newDate=new Date(times[n].getAttribute('datetime').replace(/-/g,'/').replace('T',' ').split('+')[0]);var dateString=formatterFunction(newDate,datetimeText);times[n].setAttribute('aria-label',dateString);if(tweets[n].textContent){if(supportsClassName){times[n].textContent=dateString;}else{var h=document.createElement('p');var t=document.createTextNode(dateString);h.appendChild(t);h.setAttribute('aria-label',dateString);times[n]=h;}}else{times[n].textContent=dateString;}}
var op='';if(parseLinks){if(targetBlank){targetLinksToNewWindow(tweets[n]);if(printUser){targetLinksToNewWindow(authors[n]);}}
if(printUser){op+='<div class="user">'+strip(authors[n].innerHTML)+'</div>';}
op+='<p class="tweet">'+strip(tweets[n].innerHTML)+'</p>';if(printTime){if(permalinks){op+='<p class="timePosted"><a href="'+permalinksURL[n]+'">'+times[n].getAttribute('aria-label')+'</a></p>';}else{op+='<p class="timePosted">'+
times[n].getAttribute('aria-label')+'</p>';}}}else{if(tweets[n].textContent){if(printUser){op+='<p class="user">'+authors[n].textContent+'</p>';}
op+='<p class="tweet">'+tweets[n].textContent+'</p>';if(printTime){op+='<p class="timePosted">'+times[n].textContent+'</p>';}}else{if(printUser){op+='<p class="user">'+authors[n].textContent+'</p>';}
op+='<p class="tweet">'+tweets[n].textContent+'</p>';if(printTime){op+='<p class="timePosted">'+times[n].textContent+'</p>';}}}
if(showInteractionLinks){op+='<p class="interact"><a href="https://twitter.com/intent/'+'tweet?in_reply_to='+tids[n]+'" class="twitter_reply_icon"'+
(targetBlank?' target="_blank">':'>')+'Reply</a><a href="https://twitter.com/intent/retweet?'+'tweet_id='+tids[n]+'" class="twitter_retweet_icon"'+
(targetBlank?' target="_blank">':'>')+'Retweet</a>'+'<a href="https://twitter.com/intent/favorite?tweet_id='+
tids[n]+'" class="twitter_fav_icon"'+
(targetBlank?' target="_blank">':'>')+'Favorite</a></p>';}
if(showImages&&images[n]!==undefined&&extractImageUrl(images[n])!==undefined){op+='<div class="media">'+'<img src="'+extractImageUrl(images[n])+'" alt="Image from tweet" />'+'</div>';}
if(showImages){arrayTweets.push(op);}else if(!showImages&&tweets[n].textContent.length){arrayTweets.push(op);}
n++;}}
handleTweets(arrayTweets);inProgress=false;if(queue.length>0){twitterFetcher.fetch(queue[0]);queue.splice(0,1);}}};window.__twttrf=twitterFetcher;window.twitterFetcher=twitterFetcher;return twitterFetcher;}));

;

window.TwitterView = (function(superClass) {
  extend(TwitterView, superClass);

  function TwitterView() {
    return TwitterView.__super__.constructor.apply(this, arguments);
  }

  TwitterView.prototype.initialize = function() {
    this.initializedClass = 'twitter-initialized';
    return this._validate();
  };

  TwitterView.prototype._validate = function() {
    var isInitialized, showRetweets, username;
    this.$tweetContainer = this.$("[data-twitter-tweets]", this.$el);
    username = $("[data-twitter-username]", this.$el).attr("data-twitter-username");
    showRetweets = $("[data-twitter-show-retweets]", this.$el).length;
    isInitialized = this.$el.hasClass(this.initializedClass);
    return this._fetchTweets(username, showRetweets, isInitialized);
  };

  TwitterView.prototype._fetchTweets = function(username, showRetweets, isInitialized) {
    var config;
    if (!username.length) {
      return this._hasError(false);
    }
    if (isInitialized) {
      return;
    }
    config = {
      "profile": {
        "screenName": username
      },
      "maxTweets": 3,
      "enableLinks": true,
      "showUser": true,
      "showTime": true,
      "showRetweet": showRetweets,
      "customCallback": (function(_this) {
        return function(tweets) {
          return _this._renderTweets(tweets);
        };
      })(this),
      "showInteraction": false,
      "useEmoji": true
    };
    return twitterFetcher.fetch(config);
  };

  TwitterView.prototype._renderTweets = function(tweets) {
    var j, len, results, tweet, tweetWrapper;
    tweetWrapper = $("[data-tweet]");
    if (tweets.length) {
      results = [];
      for (j = 0, len = tweets.length; j < len; j++) {
        tweet = tweets[j];
        tweetWrapper.append("<div class='twitter-tweet'>" + tweet + "</div>");
        tweetWrapper.find(".user").remove();
        results.push(tweetWrapper.find(".timePosted").addClass("accent-text").appendTo());
      }
      return results;
    } else {
      this.$tweetContainer.remove();
      return console.log("No tweets to display. Most probable cause is an incorrectly entered username.");
    }
  };

  TwitterView.prototype._hasError = function(response) {
    this.$el.toggleClass(this.initializedClass, false);
    this.$tweetContainer.html();
    if (response) {
      return console.log("Twitter error: " + response.meta.error_message);
    }
  };

  TwitterView.prototype.update = function() {
    return this._validate();
  };

  return TwitterView;

})(Backbone.View);

window.InstagramView = (function(superClass) {
  extend(InstagramView, superClass);

  function InstagramView() {
    return InstagramView.__super__.constructor.apply(this, arguments);
  }

  InstagramView.prototype.initialize = function() {
    this.initializedClass = 'instagram-initialized';
    return this._validate();
  };

  InstagramView.prototype._validate = function() {
    var accessToken, isInitialized, photoCount;
    this.$photoContainer = this.$("[data-instagram-photos]", this.$el);
    this.accessTokenError = this.$el.find('[data-instagram-error]').attr('data-instagram-error');
    accessToken = $("[data-instagram-token]", this.$el).attr("data-instagram-token");
    photoCount = $("[data-instagram-photo-count]", this.$el).attr("data-instagram-photo-count");
    isInitialized = this.$el.hasClass(this.initializedClass);
    return this._getPhotos(accessToken, photoCount, isInitialized);
  };

  InstagramView.prototype._getPhotos = function(accessToken, photoCount, isInitialized) {
    var url;
    if (!accessToken.length) {
      return this._hasError(false);
    }
    if (isInitialized) {
      return;
    }
    url = "https://api.instagram.com/v1/users/self/media/recent?access_token=" + accessToken + "&count=" + photoCount + "&callback=";
    return $.ajax({
      type: "GET",
      dataType: "jsonp",
      url: url,
      success: (function(_this) {
        return function(response) {
          var j, len, photo, ref, ref1, ref2, ref3, ref4, results;
          if (response.meta.code === 200) {
            _this.$photoContainer.empty();
            ref = response.data;
            results = [];
            for (j = 0, len = ref.length; j < len; j++) {
              photo = ref[j];
              if (photo != null ? (ref1 = photo.images) != null ? (ref2 = ref1.standard_resolution) != null ? ref2.url : void 0 : void 0 : void 0) {
                results.push(_this.$photoContainer.append("<a\n  class=\"instagram-photo\"\n  href=\"" + photo.link + "\"\n  target=\"_blank\"\n  style=\"background-image: url('" + (photo != null ? (ref3 = photo.images) != null ? (ref4 = ref3.standard_resolution) != null ? ref4.url : void 0 : void 0 : void 0) + "')\"\n>\n</a>"));
              } else {
                results.push(void 0);
              }
            }
            return results;
          } else {
            return _this._hasError(response);
          }
        };
      })(this),
      error: (function(_this) {
        return function(response) {
          return _this._hasError(response);
        };
      })(this)
    });
  };

  InstagramView.prototype._hasError = function(response) {
    this.$el.removeClass(this.initializedClass);
    this.$photoContainer.append("<div class=\"instagram-error\" data-instagram-error>" + this.accessTokenError + "</div>");
    this.$errorContainer = this.$photoContainer.find('[data-instagram-errror]');
    if (response) {
      return console.log("Instagram error: " + response.meta.error_message);
    }
  };

  InstagramView.prototype.update = function() {
    return this._validate();
  };

  return InstagramView;

})(Backbone.View);

window.SocialWidgetsView = (function(superClass) {
  extend(SocialWidgetsView, superClass);

  function SocialWidgetsView() {
    return SocialWidgetsView.__super__.constructor.apply(this, arguments);
  }

  SocialWidgetsView.prototype.initialize = function() {
    if ($('[data-instagram]', this.$el).length) {
      this.instagram = new InstagramView({
        el: this.$el
      });
    }
    if ($('[data-twitter]', this.$el).length) {
      return this.twitter = new TwitterView({
        el: this.$el
      });
    }
  };

  SocialWidgetsView.prototype.update = function($el) {
    if (this.instagram != null) {
      this.instagram.setElement($el);
      this.instagram.update();
    }
    if (this.twitter != null) {
      this.twitter.setElement($el);
      return this.twitter.update();
    }
  };

  SocialWidgetsView.prototype.remove = function() {
    var ref, ref1;
    if ((ref = this.instagram) != null) {
      ref.remove();
    }
    return (ref1 = this.twitter) != null ? ref1.remove() : void 0;
  };

  return SocialWidgetsView;

})(Backbone.View);

window.HomeView = (function(superClass) {
  extend(HomeView, superClass);

  function HomeView() {
    return HomeView.__super__.constructor.apply(this, arguments);
  }

  HomeView.prototype.initialize = function() {
    return this.sectionBinding();
  };

  HomeView.prototype.sectionBinding = function() {
    this.sections = new ThemeEditor();
    this.sections.register('home-slideshow', this.slideshow(this.sections));
    this.sections.register('featured-products', this.featuredProduct(this.sections));
    return this.sections.register('home-social-widgets', this.socialWidgets(this.sections));
  };

  HomeView.prototype.slideshow = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new SlideshowView({
          el: instance.$container
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (this.instances[instance.sectionId] == null) {
          return this.init(instance);
        }
      },
      onSectionSelect: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        return (ref = this.instances[instance.sectionId]) != null ? ref.update(instance.$container) : void 0;
      },
      onSectionDeselect: function(event) {
        return this.onSectionSelect(event);
      },
      onBlockSelect: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        return (ref = this.instances[instance.sectionId]) != null ? ref.onBlockSelect(event) : void 0;
      },
      onBlockDeselect: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        return (ref = this.instances[instance.sectionId]) != null ? ref.onBlockDeselect(event) : void 0;
      },
      onSectionUnload: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        if ((ref = this.instances[instance.sectionId]) != null) {
          ref.remove();
        }
        return delete this.instances[instance.sectionId];
      }
    };
  };

  HomeView.prototype.featuredProduct = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new ProductListView({
          el: instance.$container
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (this.instances[instance.sectionId] == null) {
          return this.init(instance);
        }
      },
      onSectionSelect: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        return (ref = this.instances[instance.sectionId]) != null ? ref.setElement(instance.$container) : void 0;
      },
      onSectionUnload: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        if ((ref = this.instances[instance.sectionId]) != null) {
          ref.remove();
        }
        return delete this.instances[instance.sectionId];
      }
    };
  };

  HomeView.prototype.socialWidgets = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new SocialWidgetsView({
          el: instance.$container
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (this.instances[instance.sectionId] == null) {
          return this.init(instance);
        }
      },
      onSectionDeselect: function(event) {
        var instance, ref, ref1;
        instance = sections.getInstance(event);
        if ((ref = this.instances[instance.sectionId]) != null) {
          ref.setElement(instance.$container);
        }
        return (ref1 = this.instances[instance.sectionId]) != null ? ref1.update(instance.$container) : void 0;
      },
      onSectionUnload: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        if ((ref = this.instances[instance.sectionId]) != null) {
          ref.remove();
        }
        return delete this.instances[instance.sectionId];
      }
    };
  };

  return HomeView;

})(Backbone.View);

window.PasswordView = (function(superClass) {
  extend(PasswordView, superClass);

  function PasswordView() {
    return PasswordView.__super__.constructor.apply(this, arguments);
  }

  PasswordView.prototype.events = {
    'click [data-close-modal]': 'closeModal',
    'click .admin-login-modal': 'openModal'
  };

  PasswordView.prototype.initialize = function() {
    this.modalWrapper = $('.password-page-modal-wrapper');
    this.modalContent = this.modalWrapper.find('.password-page-modal');
    this.openByDefault = this.modalWrapper.find('[data-open-modal]').length;
    if (this.openByDefault) {
      this.openModal();
    }
    return $(window).resize((function(_this) {
      return function() {
        return _this.positionModal();
      };
    })(this));
  };

  PasswordView.prototype.closeModal = function() {
    if (this.modalWrapper.hasClass('visible')) {
      this.modalWrapper.removeClass("visible");
      return this.$el.removeClass("scroll-locked");
    }
  };

  PasswordView.prototype.openModal = function() {
    this.$el.addClass("scroll-locked");
    this.positionModal();
    return this.modalWrapper.addClass("visible");
  };

  PasswordView.prototype.positionModal = function() {
    return this.modalContent.css({
      marginTop: -(this.modalContent.outerHeight() / 2),
      marginLeft: -(this.modalContent.outerWidth() / 2)
    });
  };

  return PasswordView;

})(Backbone.View);

window.LinkedOptions = (function() {
  function LinkedOptions(options) {
    this.options = options;
    this._init();
  }

  LinkedOptions.prototype._init = function() {
    return this._mapVariants(this.options.productJSON);
  };

  LinkedOptions.prototype._getCurrent = function(optionIndex) {
    var key, option1, option2, selector;
    if (this.options.type === 'select') {
      switch (optionIndex) {
        case 0:
          key = 'root';
          selector = this.options.$selector.eq(0);
          break;
        case 1:
          key = this.options.$selector.eq(0).val();
          selector = this.options.$selector.eq(1);
          break;
        case 2:
          key = (this.options.$selector.eq(0).val()) + " / " + (this.options.$selector.eq(1).val());
          selector = this.options.$selector.eq(2);
      }
    }
    if (this.options.type === 'radio') {
      switch (optionIndex) {
        case 0:
          key = 'root';
          selector = this.options.$selector.filter('[data-option-index=0]').filter(':checked');
          break;
        case 1:
          key = this.options.$selector.filter('[data-option-index=0]').filter(':checked').val();
          selector = this.options.$selector.filter('[data-option-index=1]').filter(':checked');
          break;
        case 2:
          option1 = this.options.$selector.filter('[data-option-index=0]').filter(':checked').val();
          option2 = this.options.$selector.filter('[data-option-index=1]').filter(':checked').val();
          key = option1 + " / " + option2;
          selector = this.options.$selector.filter('[data-option-index=2]').filter(':checked');
      }
    }
    return {
      key: key,
      selector: selector
    };
  };

  LinkedOptions.prototype._updateOptions = function(optionIndex, optionsMap) {
    var $nextOption, $option, $selector, $selectorOptions, availableOptions, initialValue, j, key, l, len, len1, nextSelector, option, ref, selector, updateSelected;
    nextSelector = optionIndex + 1;
    updateSelected = false;
    ref = this._getCurrent(optionIndex), key = ref.key, selector = ref.selector;
    availableOptions = optionsMap[key] || [];
    if (this.options.type === 'select') {
      $selector = this.options.$productForm.find(selector);
      initialValue = $selector.val();
      $selectorOptions = $selector.find('option');
      for (j = 0, len = $selectorOptions.length; j < len; j++) {
        option = $selectorOptions[j];
        $option = $(option);
        if (availableOptions.indexOf(option.value) === -1) {
          if (option.selected) {
            updateSelected = true;
          }
          $option.prop('disabled', true).prop('selected', false);
        } else {
          $option.prop('disabled', false);
        }
      }
      if (availableOptions.indexOf(initialValue) !== -1) {
        $selector.val(initialValue);
      }
      if (updateSelected) {
        $selectorOptions.filter(':not(:disabled)').eq(0).prop('selected', true);
      }
    }
    if (this.options.type === 'radio') {
      $selector = this.options.$selector.filter("[data-option-index=" + optionIndex + "]");
      for (l = 0, len1 = $selector.length; l < len1; l++) {
        option = $selector[l];
        $option = $(option);
        if (availableOptions.indexOf(option.value) === -1) {
          if (option.checked) {
            updateSelected = true;
          }
          $option.prop('disabled', true).prop('checked', false);
        } else {
          $option.prop('disabled', false);
        }
      }
      if (updateSelected) {
        $selector.filter(':not(:disabled)').eq(0).attr('checked', true).trigger('click');
      }
    }
    $selector.trigger('change');
    $nextOption = this.options.$selector.filter("[data-option-index=" + nextSelector + "]");
    if ($nextOption.length !== 0) {
      return this._updateOptions(nextSelector, optionsMap);
    }
  };

  LinkedOptions.prototype._mapVariants = function(product) {
    var j, key, len, optionsMap, ref, variant;
    optionsMap = [];
    optionsMap['root'] = [];
    ref = product.variants;
    for (j = 0, len = ref.length; j < len; j++) {
      variant = ref[j];
      if (variant.available) {
        optionsMap['root'].push(variant.option1);
        optionsMap['root'] = window.ThemeUtils.unique(optionsMap['root']);
        if (product.options.length > 1) {
          key = variant.option1;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option2);
          optionsMap[key] = window.ThemeUtils.unique(optionsMap[key]);
        }
        if (product.options.length > 2) {
          key = variant.option1 + " / " + variant.option2;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option3);
          optionsMap[key] = window.ThemeUtils.unique(optionsMap[key]);
        }
      }
    }
    this._updateOptions(0, optionsMap);
    return this.options.$selector.on('change', (function(_this) {
      return function(event) {
        var index, nextSelector;
        index = parseInt($(event.currentTarget).attr('data-option-index'), 10);
        nextSelector = index + 1;
        return _this._updateOptions(nextSelector, optionsMap);
      };
    })(this));
  };

  LinkedOptions.prototype.prepareRemove = function() {
    return this.options.$selector.off('change');
  };

  return LinkedOptions;

})();

window.ThemeUtils = {
  extend: function() {
    var dest, j, k, len, obj, objs, v;
    dest = arguments[0], objs = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    for (j = 0, len = objs.length; j < len; j++) {
      obj = objs[j];
      for (k in obj) {
        v = obj[k];
        dest[k] = v;
      }
    }
    return dest;
  },
  windowWidth: function() {
    return window.innerWidth || this.window.width();
  },
  throttle: function(func, limit) {
    var inThrottle;
    inThrottle = false;
    return function() {
      var args, context;
      args = arguments;
      context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        return setTimeout(function() {
          return inThrottle = false;
        }, limit);
      }
    };
  },
  debounce: function(func, wait, immediate) {
    var timeout;
    timeout = null;
    return function() {
      var args, callNow, context, later;
      context = this;
      args = arguments;
      later = function() {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };
      callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  },
  inViewport: function(el) {
    var bounds, rect;
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }
    rect = el.getBoundingClientRect();
    bounds = {
      top: rect.top >= 0,
      bottom: rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    };
    return bounds.top && bounds.bottom;
  },
  unique: function(array) {
    var j, key, output, ref, results, value;
    output = {};
    for (key = j = 0, ref = array.length; 0 <= ref ? j < ref : j > ref; key = 0 <= ref ? ++j : --j) {
      output[array[key]] = array[key];
    }
    results = [];
    for (key in output) {
      value = output[key];
      results.push(value);
    }
    return results;
  }
};

window.VariantHelper = (function() {
  function VariantHelper(options) {
    var defaultOptions, isShopify;
    defaultOptions = {
      $addToCartButton: null,
      $priceFields: null,
      $productForm: null,
      $productThumbnails: null,
      $selector: null,
      type: 'select',
      productJSON: null,
      productSettings: null
    };
    this.options = window.ThemeUtils.extend(defaultOptions, options);
    this.$body = $(document.body);
    this.linkedOptions = null;
    this.enableHistory = false;
    this.$masterSelect = this.options.$productForm.find(".product-select");
    isShopify = window.Shopify && window.Shopify.preview_host;
    if (window.history && window.history.replaceState && this.options.productSettings.enableHistory && !isShopify) {
      this.enableHistory = true;
    }
    this._init();
    this._bindEvents();
  }

  VariantHelper.prototype._init = function() {
    var j, len, ref, select;
    if (this.options.type === 'select') {
      ref = this.options.$selector;
      for (j = 0, len = ref.length; j < len; j++) {
        select = ref[j];
        this._setSelectLabel(null, $(select));
      }
    }
    if (this.options.productSettings.linkedOptions) {
      this.linkedOptions = new LinkedOptions(this.options);
    }
    return this._updateCurrency();
  };

  VariantHelper.prototype._bindEvents = function() {
    return this.options.$selector.on('change', (function(_this) {
      return function(event) {
        return _this._variantChange(event);
      };
    })(this));
  };

  VariantHelper.prototype._setSelectLabel = function(event, $target) {
    var selectedOption;
    if (event == null) {
      event = null;
    }
    if ($target == null) {
      $target = false;
    }
    if (!$target) {
      $target = $(event.currentTarget);
    }
    selectedOption = $target.find('option:selected').val();
    return $target.prev('[data-select-text]').find('[data-selected-option]').text(selectedOption);
  };

  VariantHelper.prototype._getCurrentOptions = function() {
    var $inputs, productOptions;
    productOptions = [];
    $inputs = this.options.$selector;
    if (this.options.type === 'radio') {
      $inputs = $inputs.filter(':checked');
    }
    $inputs.each(function(index, element) {
      return productOptions.push($(element).val());
    });
    return productOptions;
  };

  VariantHelper.prototype._getVariantFromOptions = function(productOptions) {
    var foundVariant, isMatch, j, len, ref, variant;
    if (this.options.productJSON.variants == null) {
      return;
    }
    foundVariant = null;
    ref = this.options.productJSON.variants;
    for (j = 0, len = ref.length; j < len; j++) {
      variant = ref[j];
      isMatch = productOptions.every(function(value, index) {
        return variant.options[index] === value;
      });
      if (isMatch) {
        foundVariant = variant;
      }
    }
    return foundVariant;
  };

  VariantHelper.prototype._updateMasterSelect = function(variant) {
    var ref;
    if (variant == null) {
      return;
    }
    if ((ref = this.$masterSelect.find("[data-variant-id=" + variant.id + "]")) != null) {
      ref.prop('selected', true);
    }
    return this.$masterSelect.trigger('change');
  };

  VariantHelper.prototype._updatePrice = function(variant) {
    var $addToCartButton, $moneyEl, $priceFields, attribute, j, l, len, len1, priceField, productSettings, ref, variantComparePrice, variantPrice;
    $addToCartButton = this.options.$addToCartButton;
    $priceFields = this.options.$priceFields;
    productSettings = this.options.productSettings;
    if (variant != null) {
      variantPrice = Shopify.formatMoney(variant.price, Theme.moneyFormat);
      variantComparePrice = Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat);
      for (j = 0, len = $priceFields.length; j < len; j++) {
        priceField = $priceFields[j];
        $moneyEl = $(priceField).children('.money');
        ref = $moneyEl[0].attributes;
        for (l = 0, len1 = ref.length; l < len1; l++) {
          attribute = ref[l];
          if (attribute.name.indexOf("data-") > -1) {
            $moneyEl.attr(attribute.name, "");
          }
        }
      }
      if (variant.available) {
        $addToCartButton.val(productSettings.addToCartText).removeClass('disabled').removeAttr('disabled');
      } else {
        $addToCartButton.val(productSettings.soldOutText).addClass('disabled').attr('disabled', 'disabled');
      }
      if (variant.compare_at_price > variant.price) {
        $priceFields.find('.money:first-child').html(variantPrice).attr("data-currency-" + Theme.currency, variantPrice).attr("data-currency", Theme.currency);
        $priceFields.find('.product-price-compare').html(variantComparePrice).attr("data-currency-" + Theme.currency, variantComparePrice).attr("data-currency", Theme.currency).removeClass('hidden');
      } else {
        $priceFields.find('.money').html(variantPrice).attr("data-currency-" + Theme.currency, variantPrice).attr("data-currency", Theme.currency);
        $priceFields.find('.product-price-compare').html('').attr("data-currency-" + Theme.currency, variantComparePrice).attr("data-currency", Theme.currency).addClass('hidden');
      }
    } else {
      $addToCartButton.val(productSettings.unavailableText).addClass('disabled').attr('disabled', 'disabled');
    }
    return this._updateCurrency();
  };

  VariantHelper.prototype._updateImages = function(variant) {
    var imageId, ref, ref1;
    imageId = variant != null ? (ref = variant.featured_image) != null ? ref.id : void 0 : void 0;
    if (imageId == null) {
      return;
    }
    return (ref1 = this.options.$productThumbnails) != null ? ref1.filter("[data-image-id='" + imageId + "']").trigger('click') : void 0;
  };

  VariantHelper.prototype._updateHistory = function(variant) {
    var newUrl, variantUrl;
    if (!(this.enableHistory && (variant != null))) {
      return;
    }
    newUrl = [window.location.protocol, '//', window.location.host, window.location.pathname, '?variant=', variant.id];
    variantUrl = newUrl.join('');
    return window.history.replaceState({
      path: variantUrl
    }, '', variantUrl);
  };

  VariantHelper.prototype._variantChange = function(event) {
    var productOptions, variant;
    if (this.options.type === 'select') {
      this._setSelectLabel(event);
    }
    productOptions = this._getCurrentOptions();
    variant = this._getVariantFromOptions(productOptions);
    this._updateMasterSelect(variant);
    this._updatePrice(variant);
    this._updateImages(variant);
    return this._updateHistory(variant);
  };

  VariantHelper.prototype._updateCurrency = function() {
    if (Theme.currencySwitcher) {
      return $(".currency-switcher").trigger("reset-currency");
    }
  };

  VariantHelper.prototype.prepareRemove = function() {
    var ref;
    this.options.$selector.off('change');
    return (ref = this.linkedOptions) != null ? ref.prepareRemove() : void 0;
  };

  return VariantHelper;

})();

ImageZoom = (function() {
  function ImageZoom(el) {
    this.unload = bind(this.unload, this);
    this._positionZoom = bind(this._positionZoom, this);
    this._resetZoom = bind(this._resetZoom, this);
    this._toggleZoom = bind(this._toggleZoom, this);
    this._layoutHandler = bind(this._layoutHandler, this);
    this._unbindLayoutEvent = bind(this._unbindLayoutEvent, this);
    this._bindLayoutEvent = bind(this._bindLayoutEvent, this);
    this._unbindEvents = bind(this._unbindEvents, this);
    this._bindEvents = bind(this._bindEvents, this);
    this.disableZoom = bind(this.disableZoom, this);
    this.enableZoom = bind(this.enableZoom, this);
    this.el = el;
    this.$el = $(el);
    this.$img = $(this.$el.children('img'));
    this.framerate = 60;
    this.scale = 1;
    this.zoomable = false;
    this.zoomed = false;
    this.requestAnimationFrameId = null;
    this.layoutHandler = this._layoutHandler.bind(this);
    this.resetZoom = this._resetZoom.bind(this);
    this._bindLayoutEvent();
  }

  ImageZoom.prototype.enableZoom = function() {
    this.$el.addClass('product-image-zoomable');
    return this._bindEvents();
  };

  ImageZoom.prototype.disableZoom = function() {
    this.$el.removeClass('product-image-zoomable');
    this._unbindEvents();
    return this._resetZoom();
  };

  ImageZoom.prototype._bindEvents = function() {
    this.$el.on("click.product-zoom", (function(_this) {
      return function(event) {
        return _this._toggleZoom(event.clientX, event.clientY);
      };
    })(this));
    return $(window).on("resize.product-zoom", this.resetZoom);
  };

  ImageZoom.prototype._unbindEvents = function() {
    this.$el.off("click.product-zoom");
    return $(window).off("resize.product-zoom", this.resetZoom);
  };

  ImageZoom.prototype._bindLayoutEvent = function() {
    return this.requestAnimationFrameId = window.requestAnimationFrame(this.layoutHandler);
  };

  ImageZoom.prototype._unbindLayoutEvent = function() {
    return window.cancelAnimationFrame(this.requestAnimationFrameId);
  };

  ImageZoom.prototype._layoutHandler = function() {
    var scale, zoomable;
    scale = this.$img[0].naturalWidth / this.$el[0].getBoundingClientRect().width;
    zoomable = scale >= 1.25;
    console.log(this.$img, scale, zoomable);
    if (zoomable === this.zoomable) {
      this.requestAnimationFrameId = window.requestAnimationFrame(this.layoutHandler);
      return;
    } else {
      this.scale = scale;
      this.zoomable = zoomable;
    }
    if (!this.zoomable) {
      this.disableZoom();
    } else {
      this.enableZoom();
    }
    return this.requestAnimationFrameId = window.requestAnimationFrame(this.layoutHandler);
  };

  ImageZoom.prototype._toggleZoom = function(clientX, clientY) {
    if (!this.zoomed) {
      this.$el.on("mousemove.product-zoom", ThemeUtils.throttle((function(_this) {
        return function(event) {
          return _this._positionZoom(event.clientX, event.clientY);
        };
      })(this), 1000 / this.framerate));
      this.$el.on("mouseout.product-zoom", (function(_this) {
        return function() {
          return _this._resetZoom();
        };
      })(this));
      this.$el.addClass("product-image-zoomed");
      this.$img.css("transform", "scale(" + this.scale + ")");
      this._positionZoom(clientX, clientY);
      return this.zoomed = true;
    } else {
      return this._resetZoom();
    }
  };

  ImageZoom.prototype._resetZoom = function() {
    this.$el.off("mousemove.product-zoom");
    this.$el.off("mouseout.product-zoom");
    this.$el.removeClass("product-image-zoomed");
    this.$img.css("transform", "");
    return this.zoomed = false;
  };

  ImageZoom.prototype._positionZoom = function(clientX, clientY) {
    var centerX, centerY, figHalfHeight, figHalfWidth, figRect, heightDiff, imgRect, translateX, translateY, widthDiff;
    figRect = this.$el[0].getBoundingClientRect();
    imgRect = this.$img[0].getBoundingClientRect();
    figHalfWidth = figRect.width / 2;
    figHalfHeight = figRect.height / 2;
    centerX = figRect.left + figHalfWidth;
    centerY = figRect.top + figHalfHeight;
    widthDiff = imgRect.width / 2 - figHalfWidth;
    heightDiff = imgRect.height / 2 - figHalfHeight;
    translateX = (centerX - clientX) / figHalfWidth * widthDiff / this.scale;
    translateY = (centerY - clientY) / figHalfHeight * heightDiff / this.scale;
    return this.$img.css("transform", "scale(" + this.scale + ") translate(" + translateX + "px, " + translateY + "px)");
  };

  ImageZoom.prototype.unload = function() {
    this._unbindLayoutEvent();
    return this.disableZoom();
  };

  return ImageZoom;

})();

Product = (function() {
  function Product(options) {
    var e, j, len, ref, select;
    this.el = options.el;
    this.data = options.data;
    this.product = this.data.product;
    try {
      this.enableZoom = this.data.enable_zoom;
      this.enableRelatedProducts = this.data.enable_related_products;
      this.minimumPriceArea = $(".product-price-minimum", this.el);
      this.addingToCart = false;
      this.productArea = $(".product-page", this.el);
      this.$productThumbnails = $(".product-image-thumbnails img", this.productArea);
      this.$productForm = $(".product-form", this.productArea).eq(0);
      this.$priceArea = $(".product-price", this.$productForm);
      this.$addToCartButton = $(".product-add input", this.$productForm);
      this.$variantDropdowns = $("[data-option-select]", this.$productForm);
      this.options = this.product.options;
      this.variants = this.product.variants;
      this.images = this.product.images;
      if ($(".product-form", this.el).length) {
        this.setupVariants();
      }
      if (this.enableRelatedProducts) {
        this.relatedView = new ProductListView({
          el: $(".related-products", this.el)
        });
      }
      if (this.enableZoom) {
        this.zoomView = new ImageZoom(this.el.querySelector(".product-main-image"));
      }
      ref = $("select", this.el);
      for (j = 0, len = ref.length; j < len; j++) {
        select = ref[j];
        new SelectView({
          el: select
        });
      }
      Shopify.onError = (function(_this) {
        return function(XMLHttpRequest) {
          return _this.handleErrors(XMLHttpRequest);
        };
      })(this);
      this.$productThumbnails.on('click', (function(_this) {
        return function(event) {
          return _this.switchProductImage(event);
        };
      })(this));
      this.$addToCartButton.on('click', (function(_this) {
        return function(event) {
          return _this.addToCart(event);
        };
      })(this));
      this.images = JSON.parse($("[data-images]", this.el).text());
    } catch (error1) {
      e = error1;
      console.error(e);
    }
  }

  Product.prototype.setupVariants = function() {
    var dropdownSettings;
    if (!this.$variantDropdowns.length) {
      return;
    }
    dropdownSettings = {
      $addToCartButton: this.$addToCartButton,
      $priceFields: this.$priceArea,
      $productForm: this.$productForm,
      $productThumbnails: this.$productThumbnails,
      $selector: this.$variantDropdowns,
      productSettings: this.data,
      productJSON: this.product,
      type: "select"
    };
    return this.variantHelpers = new VariantHelper(dropdownSettings);
  };

  Product.prototype.switchProductImage = function(e) {
    var $image, $nextImage, imageId;
    if (this.enableZoom) {
      this.zoomView.unload();
    }
    imageId = $(e.target, this.el).data("image-id");
    $nextImage = $(this.images[imageId]);
    $nextImage.css("display", "none");
    $image = $("[data-product-main-image]", this.el);
    $nextImage.one("load", (function(_this) {
      return function() {
        $('.product-main-image').children().not($nextImage).remove();
        $nextImage.css("display", "");
        if (_this.enableZoom) {
          return _this.zoomView = new ImageZoom(_this.el.querySelector(".product-main-image"));
        }
      };
    })(this));
    $image.after($nextImage);
    return $nextImage.trigger("theme:rimg:watch");
  };

  Product.prototype.addToCart = function(e) {
    var button;
    if (this.data.enable_cart_redirection) {
      return;
    }
    e.preventDefault();
    $(".product-message-wrapper", this.el).remove();
    if (this.addingToCart === true || this.$productForm.serialize() === "") {
      return false;
    }
    button = $(".product-add .action-btn", this.el);
    if (!button.hasClass("disabled")) {
      this.addingToCart = true;
      return $.ajax({
        type: "POST",
        url: '/cart/add.js',
        data: this.$productForm.serialize(),
        dataType: 'json',
        success: (function(_this) {
          return function(item) {
            var message;
            message = Theme.addToCartSuccess.replace("{{ product }}", "" + _this.product.title).replace("{{ cart_link }}", "<a href='/cart'>cart</a>").replace("{{ continue_link }}", "<a href='/collections/all'>Continue Shopping</a>").replace("{{ checkout_link }}", "<a href='/checkout'>check out</a>");
            return setTimeout(function() {
              $(".product-add-to-cart", _this.el).append("<li class=\"product-message-wrapper\"><p class=\"product-message\">" + message + "</p></li>").addClass("success-message").removeClass("error-message");
              _this.addingToCart = false;
              return _this.updateCart();
            }, 500);
          };
        })(this),
        error: (function(_this) {
          return function(error) {
            return _this.handleErrors(error);
          };
        })(this)
      });
    }
  };

  Product.prototype.updateCart = function() {
    return Shopify.getCart((function(_this) {
      return function(cart) {
        var cartCount, cartTotal;
        if (cart.item_count === 1) {
          cartCount = "1 item".replace("1", "" + cart.item_count);
        } else {
          cartCount = "0 items".replace("0", "" + cart.item_count);
        }
        $(".cart-item-count-wrap").text(cartCount);
        cartTotal = Shopify.formatMoney(cart.total_price, Theme.moneyFormat);
        $(".cart-amount-wrap").attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, cartTotal).attr("data-currency", Theme.currency).text(cartTotal);
        return $(".currency-switcher").trigger("reset-currency");
      };
    })(this));
  };

  Product.prototype.handleErrors = function(error) {
    return setTimeout((function(_this) {
      return function() {
        $(".product-add-to-cart", _this.el).append("<li class=\"product-message-wrapper\">\n    <p class=\"product-message\">\n        " + error.responseJSON.description + "\n    </p>\n</li>").addClass("error-message").removeClass("success-message");
        return _this.addingToCart = false;
      };
    })(this), 1000);
  };

  Product.prototype.onSectionUnload = function() {
    var ref, ref1;
    if ((ref = this.zoomView) != null) {
      ref.unload();
    }
    return (ref1 = this.relatedView) != null ? ref1.remove() : void 0;
  };

  return Product;

})();

window.QuickShopView = (function(superClass) {
  extend(QuickShopView, superClass);

  function QuickShopView() {
    return QuickShopView.__super__.constructor.apply(this, arguments);
  }

  QuickShopView.prototype.events = {
    "click .product-item-quick-shop .available": "openQuickShop",
    "click .quick-shop-modal": "closeQuickShop",
    "click .quick-shop-add": "addToCart",
    "click .quick-shop-close": "closeQuickShop",
    "click .quick-shop-close-x": "closeQuickShopWithX",
    "touchstart .quick-shop-modal": "closeQuickShop",
    "touchstart .quick-shop-close": "closeQuickShop",
    "touchstart .quick-shop-close-x": "closeQuickShopWithX"
  };

  QuickShopView.prototype.initialize = function() {
    this.quickShopModal = $(".quick-shop-modal");
    this.quickShopConfirmation = this.$(".quick-shop-confirmation");
    this.minimumPriceArea = this.$(".quick-shop-price-minimum");
    return this.addingToCart = false;
  };

  QuickShopView.prototype.openQuickShop = function(e) {
    var j, len, ref, select, target;
    e.preventDefault();
    target = $(e.currentTarget);
    this.product = target.data("product-json");
    this.enableCartRedirection = target[0].hasAttribute("data-quickshop-enable-cart-redirection");
    this.itemId = target.data("quickshop-id");
    this.quickShopContent = $("#quick-shop-" + this.itemId);
    this.setupVariants(this.quickShopContent);
    ref = this.$("select");
    for (j = 0, len = ref.length; j < len; j++) {
      select = ref[j];
      new SelectView({
        el: select
      });
    }
    this.quickShopModal.addClass("visible").append(this.quickShopContent);
    setTimeout((function(_this) {
      return function() {
        _this.quickShopModal.addClass("active");
        _this.quickShopContent.addClass("active");
        return $(document.body).addClass("quick-shop-open");
      };
    })(this), 20);
    this.positionQuickShop(this.quickShopContent);
    return Shopify.onError = (function(_this) {
      return function(XMLHttpRequest) {
        return _this.handleErrors(XMLHttpRequest);
      };
    })(this);
  };

  QuickShopView.prototype.closeQuickShopWithX = function(e, confirm, hasError) {
    var $gridItem;
    $gridItem = $("[data-product-item-id='" + this.itemId + "']");
    if (e.currentTarget) {
      this.quickShopModal.removeClass("visible");
      this.quickShopModal.removeClass("active");
      $gridItem.append(this.quickShopContent);
      this.quickShopConfirmation.removeClass("active");
      this.quickShopContent.removeClass("active");
      $(document.body).removeClass("quick-shop-open");
      return this.addingToCart = false;
    }
  };

  QuickShopView.prototype.closeQuickShop = function(e, confirm, hasError) {
    var $gridItem;
    $gridItem = $("[data-product-item-id='" + this.itemId + "']");
    if (e) {
      if (!(this.$(e.target).closest(".quick-shop-container").length || this.$(e.target).closest(".product-item-quick-shop").length)) {
        this.quickShopModal.removeClass("active").one("transitionend", (function(_this) {
          return function() {
            _this.quickShopModal.removeClass("visible");
            $gridItem.append(_this.quickShopContent);
            _this.quickShopConfirmation.removeClass("active");
            _this.quickShopContent.removeClass("active");
            $(document.body).removeClass("quick-shop-open");
            _this.addingToCart = false;
            if (hasError === "remove error") {
              return _this.$(".quick-shop-message").remove();
            }
          };
        })(this));
      }
    }
    if (confirm) {
      return this.quickShopContent.removeClass("active").one("transitionend", (function(_this) {
        return function() {
          _this.quickShopContent.off("transitionend");
          return _this.quickShopConfirmation.addClass("active");
        };
      })(this));
    }
  };

  QuickShopView.prototype.setupVariants = function(quickShopContent) {
    var $addToCartButton, $priceArea, $productJSON, $productSettings, $quickShopForm, $variantDropdowns, dropdownSettings;
    this.quickShopContent = quickShopContent;
    $quickShopForm = $(".quickshop-form", this.quickShopContent);
    this.quickshopformID = parseInt($quickShopForm.attr('data-quickshop-form'), 10);
    this.productSelect = "#product-select-" + this.quickshopformID;
    $priceArea = $('.quick-shop-price-container', this.quickShopContent);
    $addToCartButton = $(".quick-shop-add", this.quickShopContent);
    $productJSON = $("[data-quickshop-json-" + this.quickshopformID + "]", this.quickShopContent);
    $productSettings = $("[data-quickshop-settings-" + this.quickshopformID + "]", this.quickShopContent);
    this.productJSON = JSON.parse($productJSON.text());
    this.productSettings = JSON.parse($productSettings.text());
    $variantDropdowns = $("[data-option-select=" + this.quickshopformID + "]", this.quickShopContent);
    this.options = this.productJSON.options;
    this.variants = this.productJSON.variants;
    if (!$variantDropdowns.length) {
      return;
    }
    dropdownSettings = {
      $addToCartButton: $addToCartButton,
      $priceFields: $priceArea,
      $productForm: $quickShopForm,
      $selector: $variantDropdowns,
      formID: this.quickshopformID,
      productSettings: this.productSettings,
      productJSON: this.productJSON,
      type: 'select'
    };
    return this.variantHelpers = new VariantHelper(dropdownSettings);
  };

  QuickShopView.prototype.switchCurrency = function(minimum, compare) {
    var attribute, j, len, minimumPriceArea, ref;
    minimumPriceArea = this.$(".quick-shop-price-minimum");
    ref = minimumPriceArea[0].attributes;
    for (j = 0, len = ref.length; j < len; j++) {
      attribute = ref[j];
      if (attribute.name.indexOf("data-") > -1) {
        minimumPriceArea.attr(attribute.name, "");
      }
    }
    minimumPriceArea.attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, Shopify.formatMoney(minimum, Theme.moneyFormat)).attr("data-currency", Theme.currency);
    this.$(".quick-shop-price-compare").attr("data-currency-" + Theme.currency, Shopify.formatMoney(compare, Theme.moneyFormat)).attr("data-currency", Theme.currency);
    return $(".currency-switcher").trigger("reset-currency");
  };

  QuickShopView.prototype.addToCart = function(e) {
    var $form, button, formData;
    if (this.enableCartRedirection) {
      return;
    }
    if (this.addingToCart === true) {
      return false;
    }
    $form = $("#product-form-" + this.quickshopformID);
    formData = $form.serialize();
    if (formData === "") {
      return false;
    }
    e.preventDefault();
    button = $form.find(".quick-shop-add");
    if (!button.children().hasClass("disabled")) {
      this.addingToCart = true;
      return Shopify.addItemFromForm("product-form-" + this.quickshopformID, (function(_this) {
        return function(item) {
          _this.updateCart(item);
          return _this.closeQuickShop(null, true);
        };
      })(this));
    }
  };

  QuickShopView.prototype.updateCart = function(item) {
    return Shopify.getCart((function(_this) {
      return function(cart) {
        var cartCount, newFormattedAmount;
        if (cart.item_count === 1) {
          cartCount = "1 item".replace("1", "" + cart.item_count);
        } else {
          cartCount = "0 items".replace("0", "" + cart.item_count);
        }
        newFormattedAmount = Shopify.formatMoney(cart.total_price, Theme.moneyFormat);
        _this.$(".cart-item-count-wrap").text(cartCount);
        _this.$(".cart-amount-wrap").attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, newFormattedAmount).attr("data-currency", Theme.currency).html(newFormattedAmount);
        if (Theme.currencySwitcher) {
          return $(".currency-switcher").trigger("reset-currency");
        }
      };
    })(this));
  };

  QuickShopView.prototype.positionQuickShop = function(quickShop) {
    var quickShopConfirmationHeight, quickShopHeight;
    quickShopHeight = quickShop.outerHeight();
    quickShop.css({
      marginTop: quickShopHeight / -2
    });
    quickShopConfirmationHeight = this.quickShopConfirmation.outerHeight();
    return this.quickShopConfirmation.css({
      marginTop: quickShopConfirmationHeight / -2
    });
  };

  QuickShopView.prototype.handleErrors = function(error) {
    this.quickShopContent.append("<div class=\"quick-shop-message\">\n    " + error.responseJSON.description + "\n</div>");
    return setTimeout((function(_this) {
      return function() {
        _this.closeQuickShop(null, null, "remove error");
        return _this.addingToCart = false;
      };
    })(this), 1000);
  };

  return QuickShopView;

})(Backbone.View);

window.RTEView = (function(superClass) {
  extend(RTEView, superClass);

  function RTEView() {
    return RTEView.__super__.constructor.apply(this, arguments);
  }

  RTEView.prototype.initialize = function() {
    this.setupTabs();
    return this.$el.fitVids();
  };

  RTEView.prototype.setupTabs = function() {
    var groupedContent;
    return groupedContent = new GroupedContent(this.$el.get(0), {
      layout: 'tabs',
      intelliparse: false
    });
  };

  return RTEView;

})(Backbone.View);

window.SelectView = (function(superClass) {
  extend(SelectView, superClass);

  function SelectView() {
    return SelectView.__super__.constructor.apply(this, arguments);
  }

  SelectView.prototype.events = {
    "change": "updateSelectText"
  };

  SelectView.prototype.initialize = function() {
    if (!(this.$el.parent(".select-wrapper").length || this.$el.hasClass("product-variants"))) {
      this.$el.wrap("<div class='select-wrapper' />").parent().prepend('<svg role="img" class="select-dropdown"><use xlink:href="#icon-dropdown"></use></svg>').prepend("<span class='selected-text'></span>");
    }
    this.updateSelectText();
    if (!this.$el.hasClass("product-variants")) {
      this.$el.show();
    }
    return $("#address-country").on("change", (function(_this) {
      return function() {
        return _this.updateSelectText("province");
      };
    })(this));
  };

  SelectView.prototype.updateSelectText = function(select) {
    var newOption, target;
    if (select === "province") {
      target = $("#address-province");
    } else {
      target = this.$el;
    }
    newOption = target.find("option:selected").text() || target.find("option").eq(0).val();
    return target.siblings(".selected-text").text(newOption);
  };

  return SelectView;

})(Backbone.View);

window.ShareView = (function(superClass) {
  extend(ShareView, superClass);

  function ShareView() {
    return ShareView.__super__.constructor.apply(this, arguments);
  }

  ShareView.prototype.events = {
    "click": "closeShare",
    "click .share-widget-toggle": "openShare"
  };

  ShareView.prototype.openShare = function(e) {
    var otherShareWidgets, targetShareWidget;
    targetShareWidget = this.$(e.target).closest(".article-meta-wrap");
    otherShareWidgets = $(".article-meta-wrap").not(targetShareWidget);
    targetShareWidget.addClass("active");
    return otherShareWidgets.removeClass("active");
  };

  ShareView.prototype.closeShare = function(e) {
    if (!(this.$(e.target).closest(".share-widget-toggle").length || this.$(e.target).closest(".share-widget").length)) {
      return $(".article-meta-wrap").removeClass("active");
    }
  };

  return ShareView;

})(Backbone.View);

window.ThemeEditor = (function(superClass) {
  extend(ThemeEditor, superClass);

  function ThemeEditor() {
    return ThemeEditor.__super__.constructor.apply(this, arguments);
  }

  ThemeEditor.prototype.initialize = function() {
    this.instanceHandlers = {};
    this.instances = {};
    return $(document).on('shopify:section:load', (function(_this) {
      return function(event) {
        return _this._onSectionLoad(event);
      };
    })(this)).on('shopify:section:unload', (function(_this) {
      return function(event) {
        return _this._onSectionUnload(event);
      };
    })(this)).on('shopify:section:select', (function(_this) {
      return function(event) {
        return _this._onSectionSelect(event);
      };
    })(this)).on('shopify:section:deselect', (function(_this) {
      return function(event) {
        return _this._onSectionDeselect(event);
      };
    })(this)).on('shopify:section:reorder', (function(_this) {
      return function(event) {
        return _this._onSectionReorder(event);
      };
    })(this)).on('shopify:block:select', (function(_this) {
      return function(event) {
        return _this._onBlockSelect(event);
      };
    })(this)).on('shopify:block:deselect', (function(_this) {
      return function(event) {
        return _this._onBlockDeselect(event);
      };
    })(this));
  };

  ThemeEditor.prototype._findInstance = function(event) {
    var $container, instance;
    instance = this.instances[event.originalEvent.detail.sectionId];
    if (instance != null) {
      return instance;
    } else {
      $container = $('[data-section-id]', event.target);
      return this._createInstance($container);
    }
  };

  ThemeEditor.prototype._createInstance = function($container, instanceHandler) {
    var data, el, instance, sectionId, sectionType;
    el = $container.parent().get(0);
    data = this._loadData(el);
    sectionType = $container.attr('data-section-type');
    sectionId = $container.attr('data-section-id');
    if (sectionType == null) {
      return;
    }
    instanceHandler = instanceHandler || this.instanceHandlers[sectionType];
    instance = {
      instanceHandler: instanceHandler,
      el: el,
      data: data,
      $container: $container,
      sectionId: sectionId
    };
    this.instances[sectionId] = instance;
    return instance;
  };

  ThemeEditor.prototype._loadData = function(el) {
    var data, dataEl, error;
    dataEl = el.querySelector('[data-section-data]');
    if (!dataEl) {
      return {};
    }
    data = dataEl.getAttribute('data-section-data') || dataEl.innerHTML;
    try {
      return JSON.parse(data);
    } catch (error1) {
      error = error1;
      console.warn("Sections: invalid section data found. " + error.message);
      return {};
    }
  };


  /*
      Action: A section has been added or re-rendered.
      Expected: Re-execute any JavaScript needed for the section to work and
          display properly (as if the page had just been loaded).
   */

  ThemeEditor.prototype._onSectionLoad = function(event) {
    var $container, ref, ref1;
    $container = $('[data-section-id]', event.target);
    if (!$container.length) {
      return;
    }
    return (ref = this._createInstance($container)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionLoad === "function" ? ref1.onSectionLoad(event) : void 0 : void 0 : void 0;
  };


  /*
      Action: A section has been deleted or is being re-rendered.
      Expected: Clean up any event listeners, variables, etc., so that
          nothing breaks when the page is interacted with and no memory leaks occur.
   */

  ThemeEditor.prototype._onSectionUnload = function(event) {
    var instance, ref;
    instance = this._findInstance(event);
    if (instance != null) {
      if ((ref = instance.instanceHandler) != null) {
        if (typeof ref.onSectionUnload === "function") {
          ref.onSectionUnload(event);
        }
      }
    }
    if (instance) {
      return delete this.instances[instance.sectionId];
    }
  };


  /*
      Action: User has selected the section in the sidebar.
      Expected: Make sure the section is in view and stays
          in view while selected (scrolling happens automatically).
      Example: Could be used to pause a slideshow
   */

  ThemeEditor.prototype._onSectionSelect = function(event) {
    var ref, ref1;
    return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionSelect === "function" ? ref1.onSectionSelect(event) : void 0 : void 0 : void 0;
  };


  /*
      Action: User has deselected the section in the sidebar.
      Expected: (None)
      Example: Could be used to restart slideshows that are no longer being interacted with.
   */

  ThemeEditor.prototype._onSectionDeselect = function(event) {
    var ref, ref1;
    return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionDeselect === "function" ? ref1.onSectionDeselect(event) : void 0 : void 0 : void 0;
  };


  /*
      Action: User moves section in the sidebar
      Expected: (None)
      Example: Could be used to used to change high level section classes, or fire JS dependent on first section
   */

  ThemeEditor.prototype._onSectionReorder = function(event) {
    var ref, ref1;
    return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionReorder === "function" ? ref1.onSectionReorder(event) : void 0 : void 0 : void 0;
  };


  /*
      Action: User has selected the block in the sidebar.
      Expected: Make sure the block is in view and stays
          in view while selected (scrolling happens automatically).
      Example: Can be used to to trigger a slideshow to bring a slide/block into view
   */

  ThemeEditor.prototype._onBlockSelect = function(event) {
    var ref, ref1;
    return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onBlockSelect === "function" ? ref1.onBlockSelect(event) : void 0 : void 0 : void 0;
  };


  /*
      Action: User has deselected the block in the sidebar.
      Expected: (None)
      Example: Resume a slideshow
   */

  ThemeEditor.prototype._onBlockDeselect = function(event) {
    var ref, ref1;
    return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onBlockDeselect === "function" ? ref1.onBlockDeselect(event) : void 0 : void 0 : void 0;
  };


  /*
      Auto initialisation of a section for the store front
   */

  ThemeEditor.prototype._sectionInit = function(instance) {
    var ref;
    return instance != null ? (ref = instance.instanceHandler) != null ? typeof ref.init === "function" ? ref.init(instance) : void 0 : void 0 : void 0;
  };


  /*
      Registration of a section
          - Takes a string parameter as the first argument which
            matches to `[data-section-type]`
       * Example
          @sections = new Sections()
          @sections.register('some-section-type', @someSectionClass)
   */

  ThemeEditor.prototype.register = function(type, instanceHandler) {

    /*
        Storage of a instanceHandler based on the sectionType allows _onSectionLoad
           to connect a new section to it's registered instanceHandler
     */
    this.instanceHandlers[type] = instanceHandler;
    return $("[data-section-type=" + type + "]").each((function(_this) {
      return function(index, container) {
        var $container;
        $container = $(container);
        return _this._sectionInit(_this._createInstance($container, instanceHandler));
      };
    })(this));
  };


  /*
      Public method to retrieve information on an instance based on the
      bubbled `event`
   */

  ThemeEditor.prototype.getInstance = function(event) {
    return this._findInstance(event);
  };

  return ThemeEditor;

})(Backbone.View);


    /**
     * Copyright 2016 Google Inc. All Rights Reserved.
     *
     * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
     *
     *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
     *
     */
    
    (function(window, document) {
    'use strict';
    
    
    // Exits early if all IntersectionObserver and IntersectionObserverEntry
    // features are natively supported.
    if ('IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    
      // Minimal polyfill for Edge 15's lack of `isIntersecting`
      // See: https://github.com/w3c/IntersectionObserver/issues/211
      if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
        Object.defineProperty(window.IntersectionObserverEntry.prototype,
          'isIntersecting', {
          get: function () {
            return this.intersectionRatio > 0;
          }
        });
      }
      return;
    }
    
    
    /**
     * An IntersectionObserver registry. This registry exists to hold a strong
     * reference to IntersectionObserver instances currently observering a target
     * element. Without this registry, instances without another reference may be
     * garbage collected.
     */
    var registry = [];
    
    
    /**
     * Creates the global IntersectionObserverEntry constructor.
     * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
     * @param {Object} entry A dictionary of instance properties.
     * @constructor
     */
    function IntersectionObserverEntry(entry) {
      this.time = entry.time;
      this.target = entry.target;
      this.rootBounds = entry.rootBounds;
      this.boundingClientRect = entry.boundingClientRect;
      this.intersectionRect = entry.intersectionRect || getEmptyRect();
      this.isIntersecting = !!entry.intersectionRect;
    
      // Calculates the intersection ratio.
      var targetRect = this.boundingClientRect;
      var targetArea = targetRect.width * targetRect.height;
      var intersectionRect = this.intersectionRect;
      var intersectionArea = intersectionRect.width * intersectionRect.height;
    
      // Sets intersection ratio.
      if (targetArea) {
        this.intersectionRatio = intersectionArea / targetArea;
      } else {
        // If area is zero and is intersecting, sets to 1, otherwise to 0
        this.intersectionRatio = this.isIntersecting ? 1 : 0;
      }
    }
    
    
    /**
     * Creates the global IntersectionObserver constructor.
     * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
     * @param {Function} callback The function to be invoked after intersection
     *     changes have queued. The function is not invoked if the queue has
     *     been emptied by calling the `takeRecords` method.
     * @param {Object=} opt_options Optional configuration options.
     * @constructor
     */
    function IntersectionObserver(callback, opt_options) {
    
      var options = opt_options || {};
    
      if (typeof callback != 'function') {
        throw new Error('callback must be a function');
      }
    
      if (options.root && options.root.nodeType != 1) {
        throw new Error('root must be an Element');
      }
    
      // Binds and throttles `this._checkForIntersections`.
      this._checkForIntersections = throttle(
          this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
    
      // Private properties.
      this._callback = callback;
      this._observationTargets = [];
      this._queuedEntries = [];
      this._rootMarginValues = this._parseRootMargin(options.rootMargin);
    
      // Public properties.
      this.thresholds = this._initThresholds(options.threshold);
      this.root = options.root || null;
      this.rootMargin = this._rootMarginValues.map(function(margin) {
        return margin.value + margin.unit;
      }).join(' ');
    }
    
    
    /**
     * The minimum interval within which the document will be checked for
     * intersection changes.
     */
    IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
    
    
    /**
     * The frequency in which the polyfill polls for intersection changes.
     * this can be updated on a per instance basis and must be set prior to
     * calling `observe` on the first target.
     */
    IntersectionObserver.prototype.POLL_INTERVAL = null;
    
    /**
     * Use a mutation observer on the root element
     * to detect intersection changes.
     */
    IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
    
    
    /**
     * Starts observing a target element for intersection changes based on
     * the thresholds values.
     * @param {Element} target The DOM element to observe.
     */
    IntersectionObserver.prototype.observe = function(target) {
      var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
        return item.element == target;
      });
    
      if (isTargetAlreadyObserved) {
        return;
      }
    
      if (!(target && target.nodeType == 1)) {
        throw new Error('target must be an Element');
      }
    
      this._registerInstance();
      this._observationTargets.push({element: target, entry: null});
      this._monitorIntersections();
      this._checkForIntersections();
    };
    
    
    /**
     * Stops observing a target element for intersection changes.
     * @param {Element} target The DOM element to observe.
     */
    IntersectionObserver.prototype.unobserve = function(target) {
      this._observationTargets =
          this._observationTargets.filter(function(item) {
    
        return item.element != target;
      });
      if (!this._observationTargets.length) {
        this._unmonitorIntersections();
        this._unregisterInstance();
      }
    };
    
    
    /**
     * Stops observing all target elements for intersection changes.
     */
    IntersectionObserver.prototype.disconnect = function() {
      this._observationTargets = [];
      this._unmonitorIntersections();
      this._unregisterInstance();
    };
    
    
    /**
     * Returns any queue entries that have not yet been reported to the
     * callback and clears the queue. This can be used in conjunction with the
     * callback to obtain the absolute most up-to-date intersection information.
     * @return {Array} The currently queued entries.
     */
    IntersectionObserver.prototype.takeRecords = function() {
      var records = this._queuedEntries.slice();
      this._queuedEntries = [];
      return records;
    };
    
    
    /**
     * Accepts the threshold value from the user configuration object and
     * returns a sorted array of unique threshold values. If a value is not
     * between 0 and 1 and error is thrown.
     * @private
     * @param {Array|number=} opt_threshold An optional threshold value or
     *     a list of threshold values, defaulting to [0].
     * @return {Array} A sorted list of unique and valid threshold values.
     */
    IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
      var threshold = opt_threshold || [0];
      if (!Array.isArray(threshold)) threshold = [threshold];
    
      return threshold.sort().filter(function(t, i, a) {
        if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
          throw new Error('threshold must be a number between 0 and 1 inclusively');
        }
        return t !== a[i - 1];
      });
    };
    
    
    /**
     * Accepts the rootMargin value from the user configuration object
     * and returns an array of the four margin values as an object containing
     * the value and unit properties. If any of the values are not properly
     * formatted or use a unit other than px or %, and error is thrown.
     * @private
     * @param {string=} opt_rootMargin An optional rootMargin value,
     *     defaulting to '0px'.
     * @return {Array<Object>} An array of margin objects with the keys
     *     value and unit.
     */
    IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
      var marginString = opt_rootMargin || '0px';
      var margins = marginString.split(/\s+/).map(function(margin) {
        var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
        if (!parts) {
          throw new Error('rootMargin must be specified in pixels or percent');
        }
        return {value: parseFloat(parts[1]), unit: parts[2]};
      });
    
      // Handles shorthand.
      margins[1] = margins[1] || margins[0];
      margins[2] = margins[2] || margins[0];
      margins[3] = margins[3] || margins[1];
    
      return margins;
    };
    
    
    /**
     * Starts polling for intersection changes if the polling is not already
     * happening, and if the page's visibilty state is visible.
     * @private
     */
    IntersectionObserver.prototype._monitorIntersections = function() {
      if (!this._monitoringIntersections) {
        this._monitoringIntersections = true;
    
        // If a poll interval is set, use polling instead of listening to
        // resize and scroll events or DOM mutations.
        if (this.POLL_INTERVAL) {
          this._monitoringInterval = setInterval(
              this._checkForIntersections, this.POLL_INTERVAL);
        }
        else {
          addEvent(window, 'resize', this._checkForIntersections, true);
          addEvent(document, 'scroll', this._checkForIntersections, true);
    
          if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
            this._domObserver = new MutationObserver(this._checkForIntersections);
            this._domObserver.observe(document, {
              attributes: true,
              childList: true,
              characterData: true,
              subtree: true
            });
          }
        }
      }
    };
    
    
    /**
     * Stops polling for intersection changes.
     * @private
     */
    IntersectionObserver.prototype._unmonitorIntersections = function() {
      if (this._monitoringIntersections) {
        this._monitoringIntersections = false;
    
        clearInterval(this._monitoringInterval);
        this._monitoringInterval = null;
    
        removeEvent(window, 'resize', this._checkForIntersections, true);
        removeEvent(document, 'scroll', this._checkForIntersections, true);
    
        if (this._domObserver) {
          this._domObserver.disconnect();
          this._domObserver = null;
        }
      }
    };
    
    
    /**
     * Scans each observation target for intersection changes and adds them
     * to the internal entries queue. If new entries are found, it
     * schedules the callback to be invoked.
     * @private
     */
    IntersectionObserver.prototype._checkForIntersections = function() {
      var rootIsInDom = this._rootIsInDom();
      var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
    
      this._observationTargets.forEach(function(item) {
        var target = item.element;
        var targetRect = getBoundingClientRect(target);
        var rootContainsTarget = this._rootContainsTarget(target);
        var oldEntry = item.entry;
        var intersectionRect = rootIsInDom && rootContainsTarget &&
            this._computeTargetAndRootIntersection(target, rootRect);
    
        var newEntry = item.entry = new IntersectionObserverEntry({
          time: now(),
          target: target,
          boundingClientRect: targetRect,
          rootBounds: rootRect,
          intersectionRect: intersectionRect
        });
    
        if (!oldEntry) {
          this._queuedEntries.push(newEntry);
        } else if (rootIsInDom && rootContainsTarget) {
          // If the new entry intersection ratio has crossed any of the
          // thresholds, add a new entry.
          if (this._hasCrossedThreshold(oldEntry, newEntry)) {
            this._queuedEntries.push(newEntry);
          }
        } else {
          // If the root is not in the DOM or target is not contained within
          // root but the previous entry for this target had an intersection,
          // add a new record indicating removal.
          if (oldEntry && oldEntry.isIntersecting) {
            this._queuedEntries.push(newEntry);
          }
        }
      }, this);
    
      if (this._queuedEntries.length) {
        this._callback(this.takeRecords(), this);
      }
    };
    
    
    /**
     * Accepts a target and root rect computes the intersection between then
     * following the algorithm in the spec.
     * TODO(philipwalton): at this time clip-path is not considered.
     * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
     * @param {Element} target The target DOM element
     * @param {Object} rootRect The bounding rect of the root after being
     *     expanded by the rootMargin value.
     * @return {?Object} The final intersection rect object or undefined if no
     *     intersection is found.
     * @private
     */
    IntersectionObserver.prototype._computeTargetAndRootIntersection =
        function(target, rootRect) {
    
      // If the element isn't displayed, an intersection can't happen.
      if (window.getComputedStyle(target).display == 'none') return;
    
      var targetRect = getBoundingClientRect(target);
      var intersectionRect = targetRect;
      var parent = getParentNode(target);
      var atRoot = false;
    
      while (!atRoot) {
        var parentRect = null;
        var parentComputedStyle = parent.nodeType == 1 ?
            window.getComputedStyle(parent) : {};
    
        // If the parent isn't displayed, an intersection can't happen.
        if (parentComputedStyle.display == 'none') return;
    
        if (parent == this.root || parent == document) {
          atRoot = true;
          parentRect = rootRect;
        } else {
          // If the element has a non-visible overflow, and it's not the <body>
          // or <html> element, update the intersection rect.
          // Note: <body> and <html> cannot be clipped to a rect that's not also
          // the document rect, so no need to compute a new intersection.
          if (parent != document.body &&
              parent != document.documentElement &&
              parentComputedStyle.overflow != 'visible') {
            parentRect = getBoundingClientRect(parent);
          }
        }
    
        // If either of the above conditionals set a new parentRect,
        // calculate new intersection data.
        if (parentRect) {
          intersectionRect = computeRectIntersection(parentRect, intersectionRect);
    
          if (!intersectionRect) break;
        }
        parent = getParentNode(parent);
      }
      return intersectionRect;
    };
    
    
    /**
     * Returns the root rect after being expanded by the rootMargin value.
     * @return {Object} The expanded root rect.
     * @private
     */
    IntersectionObserver.prototype._getRootRect = function() {
      var rootRect;
      if (this.root) {
        rootRect = getBoundingClientRect(this.root);
      } else {
        // Use <html>/<body> instead of window since scroll bars affect size.
        var html = document.documentElement;
        var body = document.body;
        rootRect = {
          top: 0,
          left: 0,
          right: html.clientWidth || body.clientWidth,
          width: html.clientWidth || body.clientWidth,
          bottom: html.clientHeight || body.clientHeight,
          height: html.clientHeight || body.clientHeight
        };
      }
      return this._expandRectByRootMargin(rootRect);
    };
    
    
    /**
     * Accepts a rect and expands it by the rootMargin value.
     * @param {Object} rect The rect object to expand.
     * @return {Object} The expanded rect.
     * @private
     */
    IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
      var margins = this._rootMarginValues.map(function(margin, i) {
        return margin.unit == 'px' ? margin.value :
            margin.value * (i % 2 ? rect.width : rect.height) / 100;
      });
      var newRect = {
        top: rect.top - margins[0],
        right: rect.right + margins[1],
        bottom: rect.bottom + margins[2],
        left: rect.left - margins[3]
      };
      newRect.width = newRect.right - newRect.left;
      newRect.height = newRect.bottom - newRect.top;
    
      return newRect;
    };
    
    
    /**
     * Accepts an old and new entry and returns true if at least one of the
     * threshold values has been crossed.
     * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
     *    particular target element or null if no previous entry exists.
     * @param {IntersectionObserverEntry} newEntry The current entry for a
     *    particular target element.
     * @return {boolean} Returns true if a any threshold has been crossed.
     * @private
     */
    IntersectionObserver.prototype._hasCrossedThreshold =
        function(oldEntry, newEntry) {
    
      // To make comparing easier, an entry that has a ratio of 0
      // but does not actually intersect is given a value of -1
      var oldRatio = oldEntry && oldEntry.isIntersecting ?
          oldEntry.intersectionRatio || 0 : -1;
      var newRatio = newEntry.isIntersecting ?
          newEntry.intersectionRatio || 0 : -1;
    
      // Ignore unchanged ratios
      if (oldRatio === newRatio) return;
    
      for (var i = 0; i < this.thresholds.length; i++) {
        var threshold = this.thresholds[i];
    
        // Return true if an entry matches a threshold or if the new ratio
        // and the old ratio are on the opposite sides of a threshold.
        if (threshold == oldRatio || threshold == newRatio ||
            threshold < oldRatio !== threshold < newRatio) {
          return true;
        }
      }
    };
    
    
    /**
     * Returns whether or not the root element is an element and is in the DOM.
     * @return {boolean} True if the root element is an element and is in the DOM.
     * @private
     */
    IntersectionObserver.prototype._rootIsInDom = function() {
      return !this.root || containsDeep(document, this.root);
    };
    
    
    /**
     * Returns whether or not the target element is a child of root.
     * @param {Element} target The target element to check.
     * @return {boolean} True if the target element is a child of root.
     * @private
     */
    IntersectionObserver.prototype._rootContainsTarget = function(target) {
      return containsDeep(this.root || document, target);
    };
    
    
    /**
     * Adds the instance to the global IntersectionObserver registry if it isn't
     * already present.
     * @private
     */
    IntersectionObserver.prototype._registerInstance = function() {
      if (registry.indexOf(this) < 0) {
        registry.push(this);
      }
    };
    
    
    /**
     * Removes the instance from the global IntersectionObserver registry.
     * @private
     */
    IntersectionObserver.prototype._unregisterInstance = function() {
      var index = registry.indexOf(this);
      if (index != -1) registry.splice(index, 1);
    };
    
    
    /**
     * Returns the result of the performance.now() method or null in browsers
     * that don't support the API.
     * @return {number} The elapsed time since the page was requested.
     */
    function now() {
      return window.performance && performance.now && performance.now();
    }
    
    
    /**
     * Throttles a function and delays its executiong, so it's only called at most
     * once within a given time period.
     * @param {Function} fn The function to throttle.
     * @param {number} timeout The amount of time that must pass before the
     *     function can be called again.
     * @return {Function} The throttled function.
     */
    function throttle(fn, timeout) {
      var timer = null;
      return function () {
        if (!timer) {
          timer = setTimeout(function() {
            fn();
            timer = null;
          }, timeout);
        }
      };
    }
    
    
    /**
     * Adds an event handler to a DOM node ensuring cross-browser compatibility.
     * @param {Node} node The DOM node to add the event handler to.
     * @param {string} event The event name.
     * @param {Function} fn The event handler to add.
     * @param {boolean} opt_useCapture Optionally adds the even to the capture
     *     phase. Note: this only works in modern browsers.
     */
    function addEvent(node, event, fn, opt_useCapture) {
      if (typeof node.addEventListener == 'function') {
        node.addEventListener(event, fn, opt_useCapture || false);
      }
      else if (typeof node.attachEvent == 'function') {
        node.attachEvent('on' + event, fn);
      }
    }
    
    
    /**
     * Removes a previously added event handler from a DOM node.
     * @param {Node} node The DOM node to remove the event handler from.
     * @param {string} event The event name.
     * @param {Function} fn The event handler to remove.
     * @param {boolean} opt_useCapture If the event handler was added with this
     *     flag set to true, it should be set to true here in order to remove it.
     */
    function removeEvent(node, event, fn, opt_useCapture) {
      if (typeof node.removeEventListener == 'function') {
        node.removeEventListener(event, fn, opt_useCapture || false);
      }
      else if (typeof node.detatchEvent == 'function') {
        node.detatchEvent('on' + event, fn);
      }
    }
    
    
    /**
     * Returns the intersection between two rect objects.
     * @param {Object} rect1 The first rect.
     * @param {Object} rect2 The second rect.
     * @return {?Object} The intersection rect or undefined if no intersection
     *     is found.
     */
    function computeRectIntersection(rect1, rect2) {
      var top = Math.max(rect1.top, rect2.top);
      var bottom = Math.min(rect1.bottom, rect2.bottom);
      var left = Math.max(rect1.left, rect2.left);
      var right = Math.min(rect1.right, rect2.right);
      var width = right - left;
      var height = bottom - top;
    
      return (width >= 0 && height >= 0) && {
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        width: width,
        height: height
      };
    }
    
    
    /**
     * Shims the native getBoundingClientRect for compatibility with older IE.
     * @param {Element} el The element whose bounding rect to get.
     * @return {Object} The (possibly shimmed) rect of the element.
     */
    function getBoundingClientRect(el) {
      var rect;
    
      try {
        rect = el.getBoundingClientRect();
      } catch (err) {
        // Ignore Windows 7 IE11 "Unspecified error"
        // https://github.com/w3c/IntersectionObserver/pull/205
      }
    
      if (!rect) return getEmptyRect();
    
      // Older IE
      if (!(rect.width && rect.height)) {
        rect = {
          top: rect.top,
          right: rect.right,
          bottom: rect.bottom,
          left: rect.left,
          width: rect.right - rect.left,
          height: rect.bottom - rect.top
        };
      }
      return rect;
    }
    
    
    /**
     * Returns an empty rect object. An empty rect is returned when an element
     * is not in the DOM.
     * @return {Object} The empty rect.
     */
    function getEmptyRect() {
      return {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: 0,
        height: 0
      };
    }
    
    /**
     * Checks to see if a parent element contains a child elemnt (including inside
     * shadow DOM).
     * @param {Node} parent The parent element.
     * @param {Node} child The child element.
     * @return {boolean} True if the parent node contains the child node.
     */
    function containsDeep(parent, child) {
      var node = child;
      while (node) {
        if (node == parent) return true;
    
        node = getParentNode(node);
      }
      return false;
    }
    
    
    /**
     * Gets the parent node of an element or its host element if the parent node
     * is a shadow root.
     * @param {Node} node The node whose parent to get.
     * @return {Node|null} The parent node or null if no parent exists.
     */
    function getParentNode(node) {
      var parent = node.parentNode;
    
      if (parent && parent.nodeType == 11 && parent.host) {
        // If the parent is a shadow root, return the host element.
        return parent.host;
      }
      return parent;
    }
    
    
    // Exposes the constructors globally.
    window.IntersectionObserver = IntersectionObserver;
    window.IntersectionObserverEntry = IntersectionObserverEntry;
    
    }(window, document));
    
    /*!
     * rimg v2.1.2
     * (c) 2018 Pixel Union
     */
    (function (global, factory) {
    	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    	typeof define === 'function' && define.amd ? define(factory) :
    	(global.rimg = factory());
    }(this, (function () { 'use strict';
    
    /**
     * The default template render function. Turns a template string into an image
     * URL.
     *
     * @param {String} template
     * @param {Size} size
     * @returns {String}
     */
    function defaultTemplateRender(template, size) {
      return template.replace('{size}', size.width + 'x' + size.height);
    }
    
    /**
     * @type Settings
     */
    var defaults = {
      scale: 1,
      template: false,
      templateRender: defaultTemplateRender,
      max: { width: Infinity, height: Infinity },
      round: 32,
      placeholder: false
    };
    
    /**
     * Get a data attribute value from an element, with a default fallback and
     * sanitization step.
     *
     * @param {Element} el
     *
     * @param {String} name
     *        The data attribute name.
     *
     * @param {Object} options
     *        An object holding fallback values if the data attribute does not
     *        exist. If this object doesn't have the property, we further fallback
     *        to our defaults.
     *
     * @param {Function} [sanitize]
     *        A function to sanitize the data attribute value with.
     *
     * @returns {String|*}
     */
    function getData(el, name, options, sanitize) {
      var attr = 'data-rimg-' + name;
      if (!el.hasAttribute(attr)) return options[name] || defaults[name];
    
      var value = el.getAttribute(attr);
    
      return sanitize ? sanitize(value) : value;
    }
    
    /**
     * Sanitize data attributes that represent a size (in the form of `10x10`).
     *
     * @param {String} value
     * @returns {Object} An object with `width` and `height` properties.
     */
    function parseSize(value) {
      value = value.split('x');
      return { width: parseInt(value[0], 10), height: parseInt(value[1], 10) };
    }
    
    /**
     * Loads information about an element.
     *
     * Options can be set on the element itself using data attributes, or through
     * the `options` parameter. Data attributes take priority.
     *
     * @param {HTMLElement} el
     * @param {Settings} options
     * @returns {Item}
     */
    function parseItem(el) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    
      var isImage = el.hasAttribute('data-rimg-template');
    
      /**
       * @typedef {Settings} Item
       */
      return {
        el: el,
    
        // Type of element
        isImage: isImage,
        isBackgroundImage: isImage && el.tagName !== 'IMG',
    
        // Image scale
        scale: getData(el, 'scale', options),
    
        // Device density
        density: window.devicePixelRatio || 1,
    
        // Image template URL
        template: getData(el, 'template', options),
        templateRender: options.templateRender || defaults.templateRender,
    
        // Maximum image dimensions
        max: getData(el, 'max', options, parseSize),
    
        // Round image dimensions to the nearest multiple
        round: getData(el, 'round', options),
    
        // Placeholder image dimensions
        placeholder: getData(el, 'placeholder', options, parseSize)
      };
    }
    
    /**
     * Round to the nearest multiple.
     *
     * This is so we don't tax the image server too much.
     *
     * @param {Number} size The size, in pixels.
     * @param {Number} multiple The multiple to round to the nearest.
     * @returns {Number}
     */
    function roundSize(size, multiple) {
      return Math.ceil(size / multiple) * multiple;
    }
    
    /**
     * Get the size of an element.
     *
     * If it is too small, it's parent element is checked, and so on. This helps
     * avoid the situation where an element doesn't have a size yet or is positioned
     * out of the layout.
     *
     * @param {HTMLElement} el
     * @return {Object} size
     * @return {Number} size.width The width, in pixels.
     * @return {Number} size.height The height, in pixels.
     */
    function getElementSize(el) {
      var size = { width: 0, height: 0 };
    
      while (el) {
        size.width = el.offsetWidth;
        size.height = el.offsetHeight;
        if (size.width > 20 && size.height > 20) break;
        el = el.parentNode;
      }
    
      return size;
    }
    
    /**
     * Trigger a custom event.
     *
     * Note: this approach is deprecated, but still required to support older
     * browsers such as IE 10.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
     *
     * @param {HTMLElement} el
     *        The element to trigger the event on.
     *
     * @param {String} name
     *        The event name.
     *
     * @returns {Boolean}
     *          True if the event was canceled.
     */
    function trigger(el, name) {
      var event = document.createEvent('Event');
      event.initEvent(name, true, true);
      return !el.dispatchEvent(event);
    }
    
    /**
     * Return the maximum supported density of the image, given the container.
     *
     * @param {Item} item
     * @param {Size} size
     */
    function supportedDensity(item, size) {
      return Math.min(Math.min(Math.max(item.max.width / size.width, 1), item.density), Math.min(Math.max(item.max.height / size.height, 1), item.density)).toFixed(2);
    }
    
    /**
     * Set the image URL on the element. Supports background images and `srcset`.
     *
     * @param {Item} item
     * @param {Size} size
     * @param {Boolean} isPlaceholder
     */
    function setImage(item, size, isPlaceholder, onLoad) {
      var render = item.templateRender;
      var density = isPlaceholder ? 1 : supportedDensity(item, size);
      var round = isPlaceholder ? 1 : item.round;
    
      // Calculate the final display size, taking into account the image's
      // maximum dimensions.
      var width = roundSize(size.width * density, round);
      var height = roundSize(size.height * density, round);
      var ratio = Math.min(1, item.max.width / width, item.max.height / height);
      var displaySize = {
        width: Math.round(ratio * width),
        height: Math.round(ratio * height)
      };
    
      var url = render(item.template, displaySize);
    
      // On load callback
      var image = new Image();
      image.onload = onLoad;
      image.src = url;
    
      // Set image
      if (item.isBackgroundImage) {
        item.el.style.backgroundImage = 'url(\'' + url + '\')';
      } else {
        item.el.setAttribute('srcset', url + ' ' + density + 'x');
      }
    }
    
    /**
     * Load the image, set loaded status, and trigger the load event.
     *
     * @fires rimg:load
     * @fires rimg:error
     * @param {Item} item
     * @param {Size} size
     */
    function loadFullImage(item, size) {
      var el = item.el;
    
      setImage(item, size, false, function (event) {
        if (event.type === 'load') {
          el.setAttribute('data-rimg', 'loaded');
        } else {
          el.setAttribute('data-rimg', 'error');
          trigger(el, 'rimg:error');
        }
    
        trigger(el, 'rimg:load');
      });
    }
    
    /**
     * Load in a responsive image.
     *
     * Sets the image's `srcset` attribute to the final image URLs, calculated based
     * on the actual size the image is being shown at.
     *
     * @fires rimg:loading
     *        The image URLs have been set and we are waiting for them to load.
     *
     * @fires rimg:loaded
     *        The final image has loaded.
     *
     * @fires rimg:error
     *        The final image failed loading.
     *
     * @param {Item} item
     */
    function loadImage(item) {
      var el = item.el;
    
      // Already loaded?
      var status = el.getAttribute('data-rimg');
      if (status === 'loading' || status === 'loaded') return;
    
      // Is the SVG loaded?
      if (!el.complete && !item.isBackgroundImage) {
        // Wait for the load event, then call load image
        el.addEventListener('load', function cb() {
          el.removeEventListener('load', cb);
          loadImage(item);
        });
    
        return;
      }
    
      // Trigger loading event, and stop if cancelled
      if (trigger(el, 'rimg:loading')) return;
    
      // Mark as loading
      el.setAttribute('data-rimg', 'loading');
    
      // Get element size. This is used as the ideal display size.
      var size = getElementSize(item.el);
    
      size.width *= item.scale;
      size.height *= item.scale;
    
      if (item.placeholder) {
        // Load a placeholder image first, followed by the full image. Force the
        // element to keep its dimensions while it loads. If the image is smaller
        // than the element size, use the image's size. Density is taken into account
        // for HiDPI devices to avoid blurry images.
        if (!item.isBackgroundImage) {
          el.setAttribute('width', Math.min(Math.floor(item.max.width / item.density), size.width));
          el.setAttribute('height', Math.min(Math.floor(item.max.height / item.density), size.height));
        }
    
        setImage(item, item.placeholder, true, function () {
          return loadFullImage(item, size);
        });
      } else {
        loadFullImage(item, size);
      }
    }
    
    /**
     * Prepare an element to be displayed on the screen.
     *
     * Images have special logic applied to them to swap out the different sources.
     *
     * @fires rimg:enter
     *        The element is entering the viewport.
     *
     * @param {HTMLElement} el
     * @param {Settings} options
     */
    function load(el, options) {
      if (!el) return;
      trigger(el, 'rimg:enter');
    
      var item = parseItem(el, options);
    
      if (item.isImage) {
        if (!item.isBackgroundImage) {
          el.setAttribute('data-rimg-template-svg', el.getAttribute('srcset'));
        }
    
        loadImage(item);
      }
    }
    
    /**
     * Reset an element's state so that its image can be recalculated.
     *
     * @fires rimg:update
     *        The element is being updated.
     *
     * @param {HTMLElement} el
     * @param {Settings} options
     */
    function update(el, options) {
      if (!el) return;
      trigger(el, 'rimg:update');
    
      var item = parseItem(el, options);
    
      if (item.isImage) {
        if (!item.isBackgroundImage) {
          el.setAttribute('data-rimg', 'lazy');
          el.setAttribute('srcset', el.getAttribute('data-rimg-template-svg'));
        }
    
        loadImage(item);
      }
    }
    
    /**
     * Returns true if the element is within the viewport.
     * @param {HTMLElement} el
     * @returns {Boolean}
     */
    function inViewport(el) {
      var root = document.documentElement;
      var width = Math.min(root.clientWidth, window.innerWidth);
      var height = Math.min(root.clientHeight, window.innerHeight);
      var rect = el.getBoundingClientRect();
    
      return rect.bottom >= 0 && rect.right >= 0 && rect.top <= height && rect.left <= width;
    }
    
    /**
     * @typedef {Object} Size
     * @property {Number} width
     * @property {Number} height
     */
    
    /**
     * A function to turn a template string into a URL.
     *
     * @callback TemplateRenderer
     * @param {String} template
     * @param {Size} size
     * @returns {String}
     */
    
    /**
     * @typedef {Object} Settings
     *
     * @property {String} [template]
     *           A template string used to generate URLs for an image. This allows us to
     *           dynamically load images with sizes to match the container's size.
     *
     * @property {TemplateRenderer} [templateRender]
     *           A function to turn a template string into a URL.
     *
     * @property {Size} [max]
     *           The maximum available size for the image. This ensures we don't
     *           try to load an image larger than is possible.
     *
     * @property {Number} [round]
     *           Round image dimensions to the nearest multiple. This is intended to
     *           tax the image server less by lowering the number of possible image
     *           sizes requested.
     *
     * @property {Size} [placeholder]
     *           The size of the lo-fi image to load before the full image.
     */
    
    /**
     * Initialize the responsive image handler.
     *
     * @param {String|HTMLElement|NodeList} selector
     *        The CSS selector, element, or elements to track for lazy-loading.
     *
     * @param {Settings} options
     *
     * @returns {PublicApi}
     */
    function rimg() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    
      // Intersections
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            io.unobserve(entry.target);
            load(entry.target, options);
          }
        });
      }, {
        // Watch the viewport, with 20% vertical margins
        rootMargin: '20% 0px'
      });
    
      /**
       * @typedef {Object} PublicApi
       */
      var api = {
        /**
         * Track a new selector, element, or nodelist for lazy-loading.
         * @type Function
         * @param {String|HTMLElement|NodeList} selector
         */
        track: function track() {
          var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
    
          var els = querySelector(selector);
    
          for (var i = 0; i < els.length; i++) {
            // If an element is already in the viewport, load it right away. This
            // fixes a race-condition with dynamically added elements.
            if (inViewport(els[i])) {
              load(els[i], options);
            } else {
              io.observe(els[i]);
            }
          }
        },
    
    
        /**
         * Update element(s) that have already been loaded to force their images
         * to be recalculated.
         * @type Function
         * @param {String|HTMLElement|NodeList} selector
         */
        update: function update$$1() {
          var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="loaded"]';
    
          var els = querySelector(selector);
          for (var i = 0; i < els.length; i++) {
            update(els[i], options);
          }
        },
    
    
        /**
         * Stop tracking element(s) for lazy-loading.
         * @type Function
         * @param {String|HTMLElement|NodeList} selector
         */
        untrack: function untrack() {
          var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg]';
    
          var els = querySelector(selector);
          for (var i = 0; i < els.length; i++) {
            io.unobserve(els[i]);
          }
        },
    
    
        /**
         * Unload all event handlers and observers.
         * @type Function
         */
        unload: function unload() {
          io.disconnect();
        }
      };
    
      // Add initial elements
      api.track(selector);
    
      return api;
    }
    
    /**
     * Finds a group of elements on the page.
     *
     * @param {String|HTMLElement|NodeList} selector
     * @returns {Object} An array-like object.
     */
    function querySelector(selector) {
      if (typeof selector === 'string') {
        return document.querySelectorAll(selector);
      }
    
      if (selector instanceof HTMLElement) {
        return [selector];
      }
    
      if (selector instanceof NodeList) {
        return selector;
      }
    
      return [];
    }
    
    return rimg;
    
    })));
    
    /*!
     * rimg-shopify v2.2.2
     * (c) 2018 Pixel Union
     */
    (function (global, factory) {
    	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('rimg')) :
    	typeof define === 'function' && define.amd ? define(['rimg'], factory) :
    	(global.rimg = global.rimg || {}, global.rimg.shopify = factory(global.rimg));
    }(this, (function (rimg) { 'use strict';
    
    rimg = rimg && rimg.hasOwnProperty('default') ? rimg['default'] : rimg;
    
    /**
     * Polyfill for Element.matches().
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
     */
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
            i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
    }
    
    var state = {
      init: init,
      watch: watch,
      unwatch: unwatch
    };
    
    function init() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    
      state.selector = selector;
      state.instance = rimg(selector, options);
      state.loadedWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    
      // Listen for Shopify theme editor events
      document.addEventListener('shopify:section:load', function (event) {
        return watch(event.target);
      });
    
      window.addEventListener('resize', function () {
        return _update();
      });
    
      document.addEventListener('shopify:section:unload', function (event) {
        return unwatch(event.target);
      });
    
      // Listen for custom events to allow themes to hook into rimg
      document.addEventListener('theme:rimg:watch', function (event) {
        return watch(event.target);
      });
    
      document.addEventListener('theme:rimg:unwatch', function (event) {
        return unwatch(event.target);
      });
    
      // Support custom events triggered through jQuery
      // See: https://github.com/jquery/jquery/issues/3347
      if (window.jQuery) {
        jQuery(document).on({
          'theme:rimg:watch': function themeRimgWatch(event) {
            return watch(event.target);
          },
          'theme:rimg:unwatch': function themeRimgUnwatch(event) {
            return unwatch(event.target);
          }
        });
      }
    }
    
    /**
     * Track an element, and its children.
     *
     * @param {HTMLElement} el
     */
    function watch(el) {
      // Track element
      if (typeof el.matches === 'function' && el.matches(state.selector)) {
        state.instance.track(el);
      }
    
      // Track element's children
      state.instance.track(el.querySelectorAll(state.selector));
    }
    
    /**
     * Untrack an element, and its children
     *
     * @param {HTMLElement} el
     * @private
     */
    function unwatch(el) {
      // Untrack element's children
      state.instance.untrack(el.querySelectorAll(state.selector));
    
      // Untrack element
      if (typeof el.matches === 'function' && el.matches(state.selector)) {
        state.instance.untrack(el);
      }
    }
    
    /**
     * Update an element, and its children.
     *
     * @param {HTMLElement} el
     */
    function _update() {
      var currentWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    
      // Return if we're not 2x smaller, or larger than the existing loading size
      if (currentWidth / state.loadedWidth > 0.5 && currentWidth / state.loadedWidth < 2) {
        return;
      }
    
      state.loadedWidth = currentWidth;
      state.instance.update();
    }
    
    return state;
    
    })));
    
    
    /*!
     * pxs-map v1.0.2
     * (c) 2018 undefined
     */
    
    (function (global, factory) {
    	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('jquery')) :
    	typeof define === 'function' && define.amd ? define(['jquery'], factory) :
    	(global.PxsMap = factory(global.$));
    }(this, (function ($) { 'use strict';
    
    $ = $ && $.hasOwnProperty('default') ? $['default'] : $;
    
    var justDebounce = debounce;
    
    function debounce(fn, delay, at_start, guarantee) {
      var timeout;
      var args;
      var self;
    
      return function debounced() {
        self = this;
        args = Array.prototype.slice.call(arguments);
    
        if (timeout && (at_start || guarantee)) {
          return;
        } else if (!at_start) {
          clear();
    
          timeout = setTimeout(run, delay);
          return timeout;
        }
    
        timeout = setTimeout(clear, delay);
        fn.apply(self, args);
    
        function run() {
          clear();
          fn.apply(self, args);
        }
    
        function clear() {
          clearTimeout(timeout);
          timeout = null;
        }
      };
    }
    
    var classCallCheck = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };
    
    var createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
    
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    
    var PxsMap = function () {
      function PxsMap(section) {
        var _this = this;
    
        classCallCheck(this, PxsMap);
    
        this.$el = $('[data-map]', section.el);
        this.settings = section.data;
        this.map = null;
        this.center = null;
    
        this.$container = $('[data-map-container]', this.$el);
    
        // Scale so range is 12 ~ 17, rather than 1 to 6
        this.zoom = 11 + parseInt(this.settings.zoom, 10);
        if (isNaN(this.zoom)) this.zoom = 13;
    
        this.colors = null;
    
        if (this.settings.colors) {
          this.colors = this.settings.colors;
        }
    
        this.resize = this.resize.bind(this);
    
        this.address = this.settings.address;
        this.apiKey = this.settings.api_key;
    
        if (this.apiKey) {
          if (window.googleMaps === undefined) {
            window.googleMaps = true;
    
            $.getScript('https://maps.googleapis.com/maps/api/js?key=' + this.apiKey).done(function () {
              _this._createMap();
            }).fail(function (status) {
              console.error(status);
            });
          } else {
            this._createMap();
          }
        }
      }
    
      createClass(PxsMap, [{
        key: '_createMap',
        value: function _createMap() {
          var _this2 = this;
    
          return this.geolocate().done(function (results) {
            _this2.map = new google.maps.Map(_this2.$container.get(0), {
              center: results[0].geometry.location,
              clickableIcons: false,
              disableDefaultUI: true,
              disableDoubleClickZoom: true,
              gestureHandling: 'none',
              keyboardShortcuts: false,
              maxZoom: _this2.zoom,
              minZoom: _this2.zoom,
              scrollWheel: false,
              styles: _this2._getMapStyles(),
              zoom: _this2.zoom,
              zoomControl: false
            });
            _this2.center = _this2.map.getCenter();
            _this2.map.panBy(0, 0);
    
            new google.maps.Marker({
              clickable: false,
              map: _this2.map,
              position: _this2.center
            });
    
            google.maps.event.addDomListener(window, 'resize', justDebounce(_this2.resize, 250, true, true));
          }).fail(function (status) {
            var usageLimits = 'https://developers.google.com/maps/faq#usagelimits';
            var errorMessage = void 0;
    
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = '<p>Unable to find the address:</p> ' + _this2.address;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = '\n              <p>Unable to load Google Maps, you have reached your usage limit.</p>\n              <p>\n                Please visit\n                <a href="' + usageLimits + '" target="_blank">' + usageLimits + '</a>\n                for more details.\n              </p>\n            ';
                break;
              default:
                errorMessage = 'Unable to load Google Maps.';
                break;
            }
    
            _this2.displayErrorInThemeEditor(errorMessage, status);
          });
        }
      }, {
        key: 'geolocate',
        value: function geolocate() {
          var deferred = $.Deferred();
          var geocoder = new google.maps.Geocoder();
    
          geocoder.geocode({ address: this.address }, function (results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
              deferred.reject(status);
            }
    
            deferred.resolve(results);
          });
    
          return deferred;
        }
      }, {
        key: 'resize',
        value: function resize() {
          if (this.map) {
            google.maps.event.trigger(this.map, 'resize');
            this.map.setCenter(this.center);
            this.map.panBy(0, 100);
          }
        }
      }, {
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          if (this.map) {
            google.maps.event.clearListeners(this.map, 'resize');
          }
        }
      }, {
        key: '_getMapStyles',
        value: function _getMapStyles() {
          if (!this.colors) {
            return;
          }
    
          return [{ elementType: 'geometry', stylers: [{ color: this.colors.e }] }, { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] }, { elementType: 'labels.text.fill', stylers: [{ color: this.colors.a }] }, { elementType: 'labels.text.stroke', stylers: [{ color: this.colors.e }] }, { featureType: 'administrative', elementType: 'geometry', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.country', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.land_parcel', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.neighborhood', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.locality', stylers: [{ visibility: 'off' }] }, { featureType: 'poi', stylers: [{ visibility: 'off' }] }, { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: this.colors.d }] }, { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] }, { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: this.colors.c }] }, { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: this.colors.b }] }, { featureType: 'road.highway.controlled_access', stylers: [{ visibility: 'off' }] }, { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: this.colors.b }] }, { featureType: 'road.local', elementType: 'labels.text.stroke', stylers: [{ color: this.colors.e }] }, { featureType: 'transit', stylers: [{ visibility: 'off' }] }, { featureType: 'water', elementType: 'geometry', stylers: [{ color: this.colors.f }] }];
        }
      }, {
        key: 'displayErrorInThemeEditor',
        value: function displayErrorInThemeEditor(errorMessage) {
          var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    
          // Editor check
          var isThemeEditor = window.Shopify && window.Shopify.designMode;
    
          if (!isThemeEditor) {
            return;
          }
    
          this.$container.html('<div class="map-error-message">' + errorMessage + '</div>');
          console.warn(errorMessage, status);
        }
      }]);
      return PxsMap;
    }();
    
    return PxsMap;
    
    })));
    
    
    /*!
     * pxs-video v1.0.0
     * (c) 2018 Pixel Union
     */
    
    (function (global, factory) {
    	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    	typeof define === 'function' && define.amd ? define(factory) :
    	(global.PxsVideo = factory());
    }(this, (function () { 'use strict';
    
    function createCommonjsModule(fn, module) {
    	return module = { exports: {} }, fn(module, module.exports), module.exports;
    }
    
    var script = createCommonjsModule(function (module) {
    /*!
      * $script.js JS loader & dependency manager
      * https://github.com/ded/script.js
      * (c) Dustin Diaz 2014 | License MIT
      */
    
    (function (name, definition) {
      if ('object' != 'undefined' && module.exports) module.exports = definition();else if (typeof undefined == 'function' && undefined.amd) undefined(definition);else this[name] = definition();
    })('$script', function () {
      var doc = document,
          head = doc.getElementsByTagName('head')[0],
          s = 'string',
          f = false,
          push = 'push',
          readyState = 'readyState',
          onreadystatechange = 'onreadystatechange',
          list = {},
          ids = {},
          delay = {},
          scripts = {},
          scriptpath,
          urlArgs;
    
      function every(ar, fn) {
        for (var i = 0, j = ar.length; i < j; ++i) {
          if (!fn(ar[i])) return f;
        }return 1;
      }
      function each(ar, fn) {
        every(ar, function (el) {
          return !fn(el);
        });
      }
    
      function $script(paths, idOrDone, optDone) {
        paths = paths[push] ? paths : [paths];
        var idOrDoneIsDone = idOrDone && idOrDone.call,
            done = idOrDoneIsDone ? idOrDone : optDone,
            id = idOrDoneIsDone ? paths.join('') : idOrDone,
            queue = paths.length;
        function loopFn(item) {
          return item.call ? item() : list[item];
        }
        function callback() {
          if (! --queue) {
            list[id] = 1;
            done && done();
            for (var dset in delay) {
              every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = []);
            }
          }
        }
        setTimeout(function () {
          each(paths, function loading(path, force) {
            if (path === null) return callback();
    
            if (!force && !/^https?:\/\//.test(path) && scriptpath) {
              path = path.indexOf('.js') === -1 ? scriptpath + path + '.js' : scriptpath + path;
            }
    
            if (scripts[path]) {
              return scripts[path] == 2 ? callback() : setTimeout(function () {
                loading(path, true);
              }, 0);
            }
    
            scripts[path] = 1;
            create(path, callback);
          });
        }, 0);
        return $script;
      }
    
      function create(path, fn) {
        var el = doc.createElement('script'),
            loaded;
        el.onload = el.onerror = el[onreadystatechange] = function () {
          if (el[readyState] && !/^c|loade/.test(el[readyState]) || loaded) return;
          el.onload = el[onreadystatechange] = null;
          loaded = 1;
          scripts[path] = 2;
          fn();
        };
        el.async = 1;
        el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
        head.insertBefore(el, head.lastChild);
      }
    
      $script.get = create;
    
      $script.order = function (scripts, id, done) {
        (function callback(s) {
          s = scripts.shift();
          !scripts.length ? $script(s, id, done) : $script(s, callback);
        })();
      };
    
      $script.path = function (p) {
        scriptpath = p;
      };
      $script.urlArgs = function (str) {
        urlArgs = str;
      };
      $script.ready = function (deps, ready, req) {
        deps = deps[push] ? deps : [deps];
        var missing = [];
        !each(deps, function (dep) {
          list[dep] || missing[push](dep);
        }) && every(deps, function (dep) {
          return list[dep];
        }) ? ready() : !function (key) {
          delay[key] = delay[key] || [];
          delay[key][push](ready);
          req && req(missing);
        }(deps.join('|'));
        return $script;
      };
    
      $script.done = function (idOrDone) {
        $script([null], idOrDone);
      };
    
      return $script;
    });
    });
    
    var classCallCheck = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };
    
    var createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
    
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    
    var api = 'https://www.youtube.com/iframe_api';
    var apiLoadedCallbacks = [];
    var apiLoaded = false;
    
    window.onYouTubeIframeAPIReady = function () {
      apiLoadedCallbacks.forEach(function (apiLoadedCallback) {
        return apiLoadedCallback();
      });
      apiLoadedCallbacks = [];
      apiLoaded = true;
    };
    
    var Youtube = function () {
      function Youtube(el, id) {
        classCallCheck(this, Youtube);
    
        this.el = el;
        this.id = id;
    
        this.iframeEl = document.createElement('div');
        this.el.appendChild(this.iframeEl);
    
        this.onApiLoaded = this._onApiLoaded.bind(this);
    
        this.isReady = false;
        this.onReady = this._onReady.bind(this);
        this.onReadyCallback = null;
    
        this.onStateChange = this._onStateChange.bind(this);
        this.onPlayCallback = null;
    
        if (apiLoaded) {
          this._onApiLoaded();
        } else {
          apiLoadedCallbacks.push(this.onApiLoaded);
          script(api);
        }
      }
    
      createClass(Youtube, [{
        key: 'play',
        value: function play() {
          var _this = this;
    
          return new Promise(function (resolve) {
            _this.onPlayCallback = resolve;
    
            if (_this.isReady) {
              _this.player.playVideo();
            } else {
              _this.onReadyCallback = function () {
                return _this.player.playVideo();
              };
            }
          });
        }
      }, {
        key: 'unload',
        value: function unload() {
          this.player.destroy();
        }
      }, {
        key: '_onApiLoaded',
        value: function _onApiLoaded() {
          this.player = new YT.Player(this.iframeEl, {
            videoId: this.id,
            playerVars: {
              modestbranding: true,
              showinfo: false,
              controls: false
            },
            events: {
              onReady: this.onReady,
              onStateChange: this.onStateChange
            }
          });
        }
      }, {
        key: '_onReady',
        value: function _onReady() {
          this.isReady = true;
    
          if (this.onReadyCallback) {
            this.onReadyCallback();
          }
        }
      }, {
        key: '_onStateChange',
        value: function _onStateChange(event) {
          var state = event.data;
    
          if (this.onPlayCallback && state === YT.PlayerState.PLAYING) {
            this.onPlayCallback();
            this.onPlayCallback = null;
          }
        }
      }]);
      return Youtube;
    }();
    
    var api$1 = 'https://player.vimeo.com/api/player.js';
    var apiLoaded$1 = false;
    
    var VimeoPlayer = function () {
      function VimeoPlayer(el, id) {
        classCallCheck(this, VimeoPlayer);
    
        this.el = el;
        this.id = id;
    
        this.onApiLoaded = this._onApiLoaded.bind(this);
    
        this.onProgress = this._onProgress.bind(this);
        this.onProgressCallback = null;
    
        if (apiLoaded$1) {
          this._onApiLoaded();
        } else {
          script(api$1, this.onApiLoaded);
        }
      }
    
      createClass(VimeoPlayer, [{
        key: 'play',
        value: function play() {
          var _this = this;
    
          return new Promise(function (resolve) {
            _this.onProgressCallback = resolve;
            _this.player.on('progress', _this.onProgress);
            _this.player.play();
          });
        }
      }, {
        key: 'unload',
        value: function unload() {
          this.player.unload().catch();
        }
      }, {
        key: '_onApiLoaded',
        value: function _onApiLoaded() {
          this.player = new window.Vimeo.Player(this.el, { id: this.id });
    
          this.player.ready().catch();
    
          apiLoaded$1 = true;
        }
      }, {
        key: '_onProgress',
        value: function _onProgress() {
          this.player.off('progress', this.onProgress);
    
          if (this.onProgressCallback) {
            this.onProgressCallback();
            this.onProgressCallback = null;
          }
        }
      }]);
      return VimeoPlayer;
    }();
    
    var optionsDefaults = {
      autoplay: false
    };
    
    var Video = function () {
      function Video(el) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        classCallCheck(this, Video);
    
        this.el = el;
        this.playButton = el.querySelector('[data-video-play-button]');
        this.onPlayButtonClick = this._play.bind(this);
        this.video = null;
    
        var autoplay = options.autoplay || optionsDefaults.autoplay;
    
        var videoEl = el.querySelector('[data-video]');
        var type = videoEl.getAttribute('data-video');
        var id = videoEl.getAttribute('data-video-id');
    
        switch (type) {
          case 'youtube':
            this.video = new Youtube(videoEl, id);
            break;
          case 'vimeo':
            this.video = new VimeoPlayer(videoEl, id);
            break;
          default:
            this.video = null;
            break;
        }
    
        if (this.playButton) {
          this.playButton.addEventListener('click', this.onPlayButtonClick);
        }
    
        if (autoplay) {
          this._play();
        }
      }
    
      createClass(Video, [{
        key: '_play',
        value: function _play() {
          var _this = this;
    
          this.el.classList.add('video-loading');
    
          this.video.play().then(function () {
            _this.el.classList.add('video-transitioning');
    
            setTimeout(function () {
              _this.el.classList.remove('video-loading');
              _this.el.classList.remove('video-transitioning');
              _this.el.classList.add('video-playing');
            }, 200);
          });
        }
      }, {
        key: 'unload',
        value: function unload() {
          if (this.playButton) {
            this.playButton.removeEventListener('click', this.onPlayClick);
          }
    
          if (this.video) {
            this.video.unload();
          }
        }
      }]);
      return Video;
    }();
    
    var PxsVideo = function () {
      function PxsVideo(section) {
        classCallCheck(this, PxsVideo);
    
        this.video = null;
    
        var el = section.el.querySelector('[data-video-container]');
        var data = section.data;
    
        if (!el) {
          return;
        }
    
        this.video = new Video(el, {
          autoplay: data.autoplay
        });
      }
    
      createClass(PxsVideo, [{
        key: 'onSectionUnload',
        value: function onSectionUnload() {
          if (this.video) {
            this.video.unload();
          }
        }
      }]);
      return PxsVideo;
    }();
    
    return PxsVideo;
    
    })));
    
;

window.ThemeView = (function(superClass) {
  extend(ThemeView, superClass);

  function ThemeView() {
    return ThemeView.__super__.constructor.apply(this, arguments);
  }

  ThemeView.prototype.el = document.body;

  ThemeView.prototype.initialize = function() {
    var body;
    body = $(document.body);
    this.isHome = body.hasClass("template-index");
    this.isProduct = body.hasClass("template-product");
    this.isCollection = body.hasClass("template-collection");
    this.isBlog = body.hasClass("template-blog");
    this.isSearch = body.hasClass("template-search");
    this.isPasswordPage = body.hasClass("template-password");
    this.isGiftCardPage = body.hasClass("gift-card-template");
    this.hasArticle = body.find(".article-meta-wrap");
    return rimg.shopify.init();
  };

  ThemeView.prototype.render = function() {
    var j, l, len, len1, ref, ref1, results, rte, select;
    this.sections = new ThemeEditor();
    this.sections.register('header', this.headerSetup(this.sections));
    this.sections.register('pxs-map', this.mapSetup(this.sections));
    this.sections.register('pxs-video', this.videoSetup(this.sections));
    this.sections.register('static-product', this.productSetup(this.sections));
    this.sections.register('home-product', this.productSetup(this.sections));
    ref = $(".rte");
    for (j = 0, len = ref.length; j < len; j++) {
      rte = ref[j];
      new RTEView({
        el: rte
      });
    }
    if (Theme.currencySwitcher) {
      this.currencyView = new CurrencyView({
        el: this.$el
      });
    }
    if (this.isHome) {
      new HomeView({
        el: this.$el
      });
    }
    if (this.isCollection) {
      new CollectionView({
        el: this.$el
      });
    }
    if (this.isBlog) {
      new BlogView({
        el: this.$el
      });
    }
    if (this.isSearch) {
      new ProductListView({
        el: $("#search-results")
      });
    }
    if (this.hasArticle) {
      new ShareView({
        el: this.$el
      });
    }
    if (this.isPasswordPage) {
      new PasswordView({
        el: this.$el
      });
    }
    if (this.isGiftCardPage) {
      new GiftCardView();
    }
    new QuickShopView({
      el: this.$el
    });
    ref1 = $("select");
    results = [];
    for (l = 0, len1 = ref1.length; l < len1; l++) {
      select = ref1[l];
      results.push(new SelectView({
        el: select
      }));
    }
    return results;
  };

  ThemeView.prototype.headerSetup = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new HeaderView({
          el: $(".main-header")
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (!this.instances[instance.sectionId]) {
          return this.init(instance);
        }
      },
      onSectionUnload: function(event) {
        var instance;
        instance = sections.getInstance(event);
        this.instances[instance.sectionId].prepareRemove();
        this.instances[instance.sectionId].remove();
        return delete this.instances[instance.sectionId];
      }
    };
  };

  ThemeView.prototype.mapSetup = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new PxsMap({
          el: instance.el,
          data: instance.data
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (!this.instances[instance.sectionId]) {
          return this.init(instance);
        }
      },
      onSectionUnload: function(event) {
        var instance;
        instance = sections.getInstance(event);
        this.instances[instance.sectionId].onSectionUnload();
        return delete this.instances[instance.sectionId];
      }
    };
  };

  ThemeView.prototype.videoSetup = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new PxsVideo({
          el: instance.el,
          data: instance.data
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (!this.instances[instance.sectionId]) {
          return this.init(instance);
        }
      },
      onSectionUnload: function(event) {
        var instance;
        instance = sections.getInstance(event);
        this.instances[instance.sectionId].onSectionUnload();
        return delete this.instances[instance.sectionId];
      }
    };
  };

  ThemeView.prototype.productSetup = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new Product({
          el: instance.el,
          data: instance.data
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (!this.instances[instance.sectionId]) {
          return this.init(instance);
        }
      },
      onSectionUnload: function(event) {
        var instance;
        instance = sections.getInstance(event);
        this.instances[instance.sectionId].onSectionUnload();
        return delete this.instances[instance.sectionId];
      }
    };
  };

  return ThemeView;

})(Backbone.View);

$(function() {
  window.theme = new ThemeView();
  return window.theme.render();
});
